import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getData, postData, uploadFile } from '../../../../services/apiService';
import Swal from 'sweetalert2';
import EventHeader from './EventHeader';
import RegistrationSteps from './RegistrationSteps';
import IndividualForm from './IndividualForm';
import GroupForm from './GroupForm';
import ReviewSection from './ReviewSection';
import OTPModal from './OTPModal';
import TermsModal from './TermsModal';
import {
    Loader2,
    ArrowRight,
    Shield,
    IndianRupee
} from 'lucide-react';

const EventRegistrationForm = () => {
    const { eventId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [render, setRender] = useState(false);
    const [isGroupPayment, setIsGroupPayment] = useState(false);
    const [participantTypes, setParticipantTypes] = useState([]);
    const [loadingParticipantTypes, setLoadingParticipantTypes] = useState(false);
    const [data, setData] = useState();
    const [photoFile, setPhotoFile] = useState(null);
    const [hasSubEvents, setHasSubEvents] = useState(false);
    const [honorificsOptions, setHonorificsOptions] = useState([]);
    const [originalGroupData, setOriginalGroupData] = useState(null);

    // State for terms and conditions modal
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [termsLoading, setTermsLoading] = useState(false);

    // State for OTP verification
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [otpType, setOtpType] = useState('mobile'); // 'mobile' or 'email'
    const [currentContact, setCurrentContact] = useState('');
    const [currentEmail, setCurrentEmail] = useState(''); // Store email separately for email OTP
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [otpSending, setOtpSending] = useState(false);
    const [otpVerifying, setOtpVerifying] = useState(false);
    const [otpResendTimer, setOtpResendTimer] = useState(0);
    const [currentVerifyingMemberId, setCurrentVerifyingMemberId] = useState(null);
    const [verificationInProgress, setVerificationInProgress] = useState(false);

    const [subEvents, setSubEvents] = useState([]);
    const [selectedSubEvents, setSelectedSubEvents] = useState([]);
    const [loadingSubEvents, setLoadingSubEvents] = useState(false);

    // Group event states
    const [isGroupEvent, setIsGroupEvent] = useState(false);
    const [maxMembers, setMaxMembers] = useState(1);

    const [groupMembers, setGroupMembers] = useState([{
        id: 1,
        fullName: '',
        email: '',
        phone: '',
        role: '',
        gender: '',
        participantId: '',
        Ins_Name: '',
        Ins_Address: '',
        State: '',
        District: '',
        PinCode: '',
        Prefix: '',
        Comments: '',
        amount: 0,
        fetchingAmount: false,
        phoneVerified: false,
        emailVerified: false,
        verificationStep: 'phone',
        isExistingUser: false,
        autoFilled: false,
        hasCheckedExistingUser: false,
        photoFile: null,        // Add this
        photoPreview: null,      // Add this
        amountDetails: null
    }]);

    const phoneInputRef = useRef(null);
    const emailInputRef = useRef(null);
    const otpInputRefs = useRef([]);
    const contentRef = useRef(null);

    // Individual event form state
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        role: '',
        gender: '',
        participantId: '',
        Ins_Name: '',
        Ins_Address: '',
        State: '',
        District: '',
        PinCode: '',
        Prefix: '',
        Comments: '',
        amount: 0,
        phoneVerified: false,
        emailVerified: false,
        verificationStep: 'phone',
        isExistingUser: false,
        autoFilled: false,
        hasCheckedExistingUser: false,
        photoFile: null,
        photoPreview: null,
        // Add any other fields that might come from API
        amountDetails: null // Store amount details if needed
    });

    // Registration flow state
    const [registrationStep, setRegistrationStep] = useState('form'); // 'form', 'review', 'payment'
    const [totalAmount, setTotalAmount] = useState(0);
    const [registrationId, setRegistrationId] = useState(null);
    const [countries, setCountries] = useState([]);
    const [verificationKey, setVerificationKey] = useState(0); useEffect(() => {
        const fetchParticipantTypes = async () => {
            try {
                const response = await getData(`Event/GetPrefixes`);

                if (response && !response.isError && response.data) {
                    setHonorificsOptions(response.data)
                }
            } catch (error) {
                console.error('Error fetching participant types:', error);
            }
        };

        fetchParticipantTypes();
    }, []);
    // Terms and Conditions content
    const termsAndConditions = [
        "Payment is non-refundable once processed.",
        "Event registration is subject to availability.",
        "The event organizer reserves the right to cancel or reschedule the event.",
        "In case of event cancellation, registration fees will be refunded within 7-10 business days.",
        "All personal information provided will be kept confidential and used only for event purposes.",
        "By proceeding with payment, you agree to abide by all event rules and regulations.",
        "The event organizer is not responsible for any loss or damage to personal belongings.",
        "Photography and videography may be conducted during the event for promotional purposes.",
        "Participants must adhere to the event code of conduct.",
        "Late arrivals may not be accommodated."
    ];


    useEffect(() => {
        const fetchCountries = async () => {
            try {
                // const response = await fetch(
                //     "https://campus.psgtech.ac.in/userpsgApi/umapi/external/Country"
                // );

                const response = {
                    "countries": [
                        {
                            "countryId": 1,
                            "shortName": "AF  ",
                            "countryName": "Afghanistan",
                            "phoneCode": "93"
                        },
                        {
                            "countryId": 2,
                            "shortName": "AL  ",
                            "countryName": "Albania",
                            "phoneCode": "355"
                        },
                        {
                            "countryId": 3,
                            "shortName": "DZ  ",
                            "countryName": "Algeria",
                            "phoneCode": "213"
                        },
                        {
                            "countryId": 4,
                            "shortName": "AS  ",
                            "countryName": "American Samoa",
                            "phoneCode": "1684"
                        },
                        {
                            "countryId": 5,
                            "shortName": "AD  ",
                            "countryName": "Andorra",
                            "phoneCode": "376"
                        },
                        {
                            "countryId": 6,
                            "shortName": "AO  ",
                            "countryName": "Angola",
                            "phoneCode": "244"
                        },
                        {
                            "countryId": 7,
                            "shortName": "AI  ",
                            "countryName": "Anguilla",
                            "phoneCode": "1264"
                        },
                        {
                            "countryId": 8,
                            "shortName": "AQ  ",
                            "countryName": "Antarctica",
                            "phoneCode": "0"
                        },
                        {
                            "countryId": 9,
                            "shortName": "AG  ",
                            "countryName": "Antigua And Barbuda",
                            "phoneCode": "1268"
                        },
                        {
                            "countryId": 10,
                            "shortName": "AR  ",
                            "countryName": "Argentina",
                            "phoneCode": "54"
                        },
                        {
                            "countryId": 11,
                            "shortName": "AM  ",
                            "countryName": "Armenia",
                            "phoneCode": "374"
                        },
                        {
                            "countryId": 12,
                            "shortName": "AW  ",
                            "countryName": "Aruba",
                            "phoneCode": "297"
                        },
                        {
                            "countryId": 13,
                            "shortName": "AU  ",
                            "countryName": "Australia",
                            "phoneCode": "61"
                        },
                        {
                            "countryId": 14,
                            "shortName": "AT  ",
                            "countryName": "Austria",
                            "phoneCode": "43"
                        },
                        {
                            "countryId": 15,
                            "shortName": "AZ  ",
                            "countryName": "Azerbaijan",
                            "phoneCode": "994"
                        },
                        {
                            "countryId": 16,
                            "shortName": "BS  ",
                            "countryName": "Bahamas The",
                            "phoneCode": "1242"
                        },
                        {
                            "countryId": 17,
                            "shortName": "BH  ",
                            "countryName": "Bahrain",
                            "phoneCode": "973"
                        },
                        {
                            "countryId": 18,
                            "shortName": "BD  ",
                            "countryName": "Bangladesh",
                            "phoneCode": "880"
                        },
                        {
                            "countryId": 19,
                            "shortName": "BB  ",
                            "countryName": "Barbados",
                            "phoneCode": "1246"
                        },
                        {
                            "countryId": 20,
                            "shortName": "BY  ",
                            "countryName": "Belarus",
                            "phoneCode": "375"
                        },
                        {
                            "countryId": 21,
                            "shortName": "BE  ",
                            "countryName": "Belgium",
                            "phoneCode": "32"
                        },
                        {
                            "countryId": 22,
                            "shortName": "BZ  ",
                            "countryName": "Belize",
                            "phoneCode": "501"
                        },
                        {
                            "countryId": 23,
                            "shortName": "BJ  ",
                            "countryName": "Benin",
                            "phoneCode": "229"
                        },
                        {
                            "countryId": 24,
                            "shortName": "BM  ",
                            "countryName": "Bermuda",
                            "phoneCode": "1441"
                        },
                        {
                            "countryId": 25,
                            "shortName": "BT  ",
                            "countryName": "Bhutan",
                            "phoneCode": "975"
                        },
                        {
                            "countryId": 26,
                            "shortName": "BO  ",
                            "countryName": "Bolivia",
                            "phoneCode": "591"
                        },
                        {
                            "countryId": 27,
                            "shortName": "BA  ",
                            "countryName": "Bosnia and Herzegovina",
                            "phoneCode": "387"
                        },
                        {
                            "countryId": 28,
                            "shortName": "BW  ",
                            "countryName": "Botswana",
                            "phoneCode": "267"
                        },
                        {
                            "countryId": 29,
                            "shortName": "BV  ",
                            "countryName": "Bouvet Island",
                            "phoneCode": "0"
                        },
                        {
                            "countryId": 30,
                            "shortName": "BR  ",
                            "countryName": "Brazil",
                            "phoneCode": "55"
                        },
                        {
                            "countryId": 31,
                            "shortName": "IO  ",
                            "countryName": "British Indian Ocean Territory",
                            "phoneCode": "246"
                        },
                        {
                            "countryId": 32,
                            "shortName": "BN  ",
                            "countryName": "Brunei",
                            "phoneCode": "673"
                        },
                        {
                            "countryId": 33,
                            "shortName": "BG  ",
                            "countryName": "Bulgaria",
                            "phoneCode": "359"
                        },
                        {
                            "countryId": 34,
                            "shortName": "BF  ",
                            "countryName": "Burkina Faso",
                            "phoneCode": "226"
                        },
                        {
                            "countryId": 35,
                            "shortName": "BI  ",
                            "countryName": "Burundi",
                            "phoneCode": "257"
                        },
                        {
                            "countryId": 36,
                            "shortName": "KH  ",
                            "countryName": "Cambodia",
                            "phoneCode": "855"
                        },
                        {
                            "countryId": 37,
                            "shortName": "CM  ",
                            "countryName": "Cameroon",
                            "phoneCode": "237"
                        },
                        {
                            "countryId": 38,
                            "shortName": "CA  ",
                            "countryName": "Canada",
                            "phoneCode": "1"
                        },
                        {
                            "countryId": 39,
                            "shortName": "CV  ",
                            "countryName": "Cape Verde",
                            "phoneCode": "238"
                        },
                        {
                            "countryId": 40,
                            "shortName": "KY  ",
                            "countryName": "Cayman Islands",
                            "phoneCode": "1345"
                        },
                        {
                            "countryId": 41,
                            "shortName": "CF  ",
                            "countryName": "Central African Republic",
                            "phoneCode": "236"
                        },
                        {
                            "countryId": 42,
                            "shortName": "TD  ",
                            "countryName": "Chad",
                            "phoneCode": "235"
                        },
                        {
                            "countryId": 43,
                            "shortName": "CL  ",
                            "countryName": "Chile",
                            "phoneCode": "56"
                        },
                        {
                            "countryId": 44,
                            "shortName": "CN  ",
                            "countryName": "China",
                            "phoneCode": "86"
                        },
                        {
                            "countryId": 45,
                            "shortName": "CX  ",
                            "countryName": "Christmas Island",
                            "phoneCode": "61"
                        },
                        {
                            "countryId": 46,
                            "shortName": "CC  ",
                            "countryName": "Cocos (Keeling) Islands",
                            "phoneCode": "672"
                        },
                        {
                            "countryId": 47,
                            "shortName": "CO  ",
                            "countryName": "Colombia",
                            "phoneCode": "57"
                        },
                        {
                            "countryId": 48,
                            "shortName": "KM  ",
                            "countryName": "Comoros",
                            "phoneCode": "269"
                        },
                        {
                            "countryId": 49,
                            "shortName": "CG  ",
                            "countryName": "Republic Of The Congo",
                            "phoneCode": "242"
                        },
                        {
                            "countryId": 50,
                            "shortName": "CD  ",
                            "countryName": "Democratic Republic Of The Congo",
                            "phoneCode": "242"
                        },
                        {
                            "countryId": 51,
                            "shortName": "CK  ",
                            "countryName": "Cook Islands",
                            "phoneCode": "682"
                        },
                        {
                            "countryId": 52,
                            "shortName": "CR  ",
                            "countryName": "Costa Rica",
                            "phoneCode": "506"
                        },
                        {
                            "countryId": 53,
                            "shortName": "CI  ",
                            "countryName": "Cote D Ivoire (Ivory Coast)",
                            "phoneCode": "225"
                        },
                        {
                            "countryId": 54,
                            "shortName": "HR  ",
                            "countryName": "Croatia (Hrvatska)",
                            "phoneCode": "385"
                        },
                        {
                            "countryId": 55,
                            "shortName": "CU  ",
                            "countryName": "Cuba",
                            "phoneCode": "53"
                        },
                        {
                            "countryId": 56,
                            "shortName": "CY  ",
                            "countryName": "Cyprus",
                            "phoneCode": "357"
                        },
                        {
                            "countryId": 57,
                            "shortName": "CZ  ",
                            "countryName": "Czech Republic",
                            "phoneCode": "420"
                        },
                        {
                            "countryId": 58,
                            "shortName": "DK  ",
                            "countryName": "Denmark",
                            "phoneCode": "45"
                        },
                        {
                            "countryId": 59,
                            "shortName": "DJ  ",
                            "countryName": "Djibouti",
                            "phoneCode": "253"
                        },
                        {
                            "countryId": 60,
                            "shortName": "DM  ",
                            "countryName": "Dominica",
                            "phoneCode": "1767"
                        },
                        {
                            "countryId": 61,
                            "shortName": "DO  ",
                            "countryName": "Dominican Republic",
                            "phoneCode": "1809"
                        },
                        {
                            "countryId": 62,
                            "shortName": "TP  ",
                            "countryName": "East Timor",
                            "phoneCode": "670"
                        },
                        {
                            "countryId": 63,
                            "shortName": "EC  ",
                            "countryName": "Ecuador",
                            "phoneCode": "593"
                        },
                        {
                            "countryId": 64,
                            "shortName": "EG  ",
                            "countryName": "Egypt",
                            "phoneCode": "20"
                        },
                        {
                            "countryId": 65,
                            "shortName": "SV  ",
                            "countryName": "El Salvador",
                            "phoneCode": "503"
                        },
                        {
                            "countryId": 66,
                            "shortName": "GQ  ",
                            "countryName": "Equatorial Guinea",
                            "phoneCode": "240"
                        },
                        {
                            "countryId": 67,
                            "shortName": "ER  ",
                            "countryName": "Eritrea",
                            "phoneCode": "291"
                        },
                        {
                            "countryId": 68,
                            "shortName": "EE  ",
                            "countryName": "Estonia",
                            "phoneCode": "372"
                        },
                        {
                            "countryId": 69,
                            "shortName": "ET  ",
                            "countryName": "Ethiopia",
                            "phoneCode": "251"
                        },
                        {
                            "countryId": 70,
                            "shortName": "XA  ",
                            "countryName": "External Territories of Australia",
                            "phoneCode": "61"
                        },
                        {
                            "countryId": 71,
                            "shortName": "FK  ",
                            "countryName": "Falkland Islands",
                            "phoneCode": "500"
                        },
                        {
                            "countryId": 72,
                            "shortName": "FO  ",
                            "countryName": "Faroe Islands",
                            "phoneCode": "298"
                        },
                        {
                            "countryId": 73,
                            "shortName": "FJ  ",
                            "countryName": "Fiji Islands",
                            "phoneCode": "679"
                        },
                        {
                            "countryId": 74,
                            "shortName": "FI  ",
                            "countryName": "Finland",
                            "phoneCode": "358"
                        },
                        {
                            "countryId": 75,
                            "shortName": "FR  ",
                            "countryName": "France",
                            "phoneCode": "33"
                        },
                        {
                            "countryId": 76,
                            "shortName": "GF  ",
                            "countryName": "French Guiana",
                            "phoneCode": "594"
                        },
                        {
                            "countryId": 77,
                            "shortName": "PF  ",
                            "countryName": "French Polynesia",
                            "phoneCode": "689"
                        },
                        {
                            "countryId": 78,
                            "shortName": "TF  ",
                            "countryName": "French Southern Territories",
                            "phoneCode": "0"
                        },
                        {
                            "countryId": 79,
                            "shortName": "GA  ",
                            "countryName": "Gabon",
                            "phoneCode": "241"
                        },
                        {
                            "countryId": 80,
                            "shortName": "GM  ",
                            "countryName": "Gambia The",
                            "phoneCode": "220"
                        },
                        {
                            "countryId": 81,
                            "shortName": "GE  ",
                            "countryName": "Georgia",
                            "phoneCode": "995"
                        },
                        {
                            "countryId": 82,
                            "shortName": "DE  ",
                            "countryName": "Germany",
                            "phoneCode": "49"
                        },
                        {
                            "countryId": 83,
                            "shortName": "GH  ",
                            "countryName": "Ghana",
                            "phoneCode": "233"
                        },
                        {
                            "countryId": 84,
                            "shortName": "GI  ",
                            "countryName": "Gibraltar",
                            "phoneCode": "350"
                        },
                        {
                            "countryId": 85,
                            "shortName": "GR  ",
                            "countryName": "Greece",
                            "phoneCode": "30"
                        },
                        {
                            "countryId": 86,
                            "shortName": "GL  ",
                            "countryName": "Greenland",
                            "phoneCode": "299"
                        },
                        {
                            "countryId": 87,
                            "shortName": "GD  ",
                            "countryName": "Grenada",
                            "phoneCode": "1473"
                        },
                        {
                            "countryId": 88,
                            "shortName": "GP  ",
                            "countryName": "Guadeloupe",
                            "phoneCode": "590"
                        },
                        {
                            "countryId": 89,
                            "shortName": "GU  ",
                            "countryName": "Guam",
                            "phoneCode": "1671"
                        },
                        {
                            "countryId": 90,
                            "shortName": "GT  ",
                            "countryName": "Guatemala",
                            "phoneCode": "502"
                        },
                        {
                            "countryId": 91,
                            "shortName": "XU  ",
                            "countryName": "Guernsey and Alderney",
                            "phoneCode": "44"
                        },
                        {
                            "countryId": 92,
                            "shortName": "GN  ",
                            "countryName": "Guinea",
                            "phoneCode": "224"
                        },
                        {
                            "countryId": 93,
                            "shortName": "GW  ",
                            "countryName": "Guinea-Bissau",
                            "phoneCode": "245"
                        },
                        {
                            "countryId": 94,
                            "shortName": "GY  ",
                            "countryName": "Guyana",
                            "phoneCode": "592"
                        },
                        {
                            "countryId": 95,
                            "shortName": "HT  ",
                            "countryName": "Haiti",
                            "phoneCode": "509"
                        },
                        {
                            "countryId": 96,
                            "shortName": "HM  ",
                            "countryName": "Heard and McDonald Islands",
                            "phoneCode": "0"
                        },
                        {
                            "countryId": 97,
                            "shortName": "HN  ",
                            "countryName": "Honduras",
                            "phoneCode": "504"
                        },
                        {
                            "countryId": 98,
                            "shortName": "HK  ",
                            "countryName": "Hong Kong S.A.R.",
                            "phoneCode": "852"
                        },
                        {
                            "countryId": 99,
                            "shortName": "HU  ",
                            "countryName": "Hungary",
                            "phoneCode": "36"
                        },
                        {
                            "countryId": 100,
                            "shortName": "IS  ",
                            "countryName": "Iceland",
                            "phoneCode": "354"
                        },
                        {
                            "countryId": 101,
                            "shortName": "IN  ",
                            "countryName": "India",
                            "phoneCode": "91"
                        },
                        {
                            "countryId": 102,
                            "shortName": "ID  ",
                            "countryName": "Indonesia",
                            "phoneCode": "62"
                        },
                        {
                            "countryId": 103,
                            "shortName": "IR  ",
                            "countryName": "Iran",
                            "phoneCode": "98"
                        },
                        {
                            "countryId": 104,
                            "shortName": "IQ  ",
                            "countryName": "Iraq",
                            "phoneCode": "964"
                        },
                        {
                            "countryId": 105,
                            "shortName": "IE  ",
                            "countryName": "Ireland",
                            "phoneCode": "353"
                        },
                        {
                            "countryId": 106,
                            "shortName": "IL  ",
                            "countryName": "Israel",
                            "phoneCode": "972"
                        },
                        {
                            "countryId": 107,
                            "shortName": "IT  ",
                            "countryName": "Italy",
                            "phoneCode": "39"
                        },
                        {
                            "countryId": 108,
                            "shortName": "JM  ",
                            "countryName": "Jamaica",
                            "phoneCode": "1876"
                        },
                        {
                            "countryId": 109,
                            "shortName": "JP  ",
                            "countryName": "Japan",
                            "phoneCode": "81"
                        },
                        {
                            "countryId": 110,
                            "shortName": "XJ  ",
                            "countryName": "Jersey",
                            "phoneCode": "44"
                        },
                        {
                            "countryId": 111,
                            "shortName": "JO  ",
                            "countryName": "Jordan",
                            "phoneCode": "962"
                        },
                        {
                            "countryId": 112,
                            "shortName": "KZ  ",
                            "countryName": "Kazakhstan",
                            "phoneCode": "7"
                        },
                        {
                            "countryId": 113,
                            "shortName": "KE  ",
                            "countryName": "Kenya",
                            "phoneCode": "254"
                        },
                        {
                            "countryId": 114,
                            "shortName": "KI  ",
                            "countryName": "Kiribati",
                            "phoneCode": "686"
                        },
                        {
                            "countryId": 115,
                            "shortName": "KP  ",
                            "countryName": "Korea North",
                            "phoneCode": "850"
                        },
                        {
                            "countryId": 116,
                            "shortName": "KR  ",
                            "countryName": "Korea South",
                            "phoneCode": "82"
                        },
                        {
                            "countryId": 117,
                            "shortName": "KW  ",
                            "countryName": "Kuwait",
                            "phoneCode": "965"
                        },
                        {
                            "countryId": 118,
                            "shortName": "KG  ",
                            "countryName": "Kyrgyzstan",
                            "phoneCode": "996"
                        },
                        {
                            "countryId": 119,
                            "shortName": "LA  ",
                            "countryName": "Laos",
                            "phoneCode": "856"
                        },
                        {
                            "countryId": 120,
                            "shortName": "LV  ",
                            "countryName": "Latvia",
                            "phoneCode": "371"
                        },
                        {
                            "countryId": 121,
                            "shortName": "LB  ",
                            "countryName": "Lebanon",
                            "phoneCode": "961"
                        },
                        {
                            "countryId": 122,
                            "shortName": "LS  ",
                            "countryName": "Lesotho",
                            "phoneCode": "266"
                        },
                        {
                            "countryId": 123,
                            "shortName": "LR  ",
                            "countryName": "Liberia",
                            "phoneCode": "231"
                        },
                        {
                            "countryId": 124,
                            "shortName": "LY  ",
                            "countryName": "Libya",
                            "phoneCode": "218"
                        },
                        {
                            "countryId": 125,
                            "shortName": "LI  ",
                            "countryName": "Liechtenstein",
                            "phoneCode": "423"
                        },
                        {
                            "countryId": 126,
                            "shortName": "LT  ",
                            "countryName": "Lithuania",
                            "phoneCode": "370"
                        },
                        {
                            "countryId": 127,
                            "shortName": "LU  ",
                            "countryName": "Luxembourg",
                            "phoneCode": "352"
                        },
                        {
                            "countryId": 128,
                            "shortName": "MO  ",
                            "countryName": "Macau S.A.R.",
                            "phoneCode": "853"
                        },
                        {
                            "countryId": 129,
                            "shortName": "MK  ",
                            "countryName": "Macedonia",
                            "phoneCode": "389"
                        },
                        {
                            "countryId": 130,
                            "shortName": "MG  ",
                            "countryName": "Madagascar",
                            "phoneCode": "261"
                        },
                        {
                            "countryId": 131,
                            "shortName": "MW  ",
                            "countryName": "Malawi",
                            "phoneCode": "265"
                        },
                        {
                            "countryId": 132,
                            "shortName": "MY  ",
                            "countryName": "Malaysia",
                            "phoneCode": "60"
                        },
                        {
                            "countryId": 133,
                            "shortName": "MV  ",
                            "countryName": "Maldives",
                            "phoneCode": "960"
                        },
                        {
                            "countryId": 134,
                            "shortName": "ML  ",
                            "countryName": "Mali",
                            "phoneCode": "223"
                        },
                        {
                            "countryId": 135,
                            "shortName": "MT  ",
                            "countryName": "Malta",
                            "phoneCode": "356"
                        },
                        {
                            "countryId": 136,
                            "shortName": "XM  ",
                            "countryName": "Man (Isle of)",
                            "phoneCode": "44"
                        },
                        {
                            "countryId": 137,
                            "shortName": "MH  ",
                            "countryName": "Marshall Islands",
                            "phoneCode": "692"
                        },
                        {
                            "countryId": 138,
                            "shortName": "MQ  ",
                            "countryName": "Martinique",
                            "phoneCode": "596"
                        },
                        {
                            "countryId": 139,
                            "shortName": "MR  ",
                            "countryName": "Mauritania",
                            "phoneCode": "222"
                        },
                        {
                            "countryId": 140,
                            "shortName": "MU  ",
                            "countryName": "Mauritius",
                            "phoneCode": "230"
                        },
                        {
                            "countryId": 141,
                            "shortName": "YT  ",
                            "countryName": "Mayotte",
                            "phoneCode": "269"
                        },
                        {
                            "countryId": 142,
                            "shortName": "MX  ",
                            "countryName": "Mexico",
                            "phoneCode": "52"
                        },
                        {
                            "countryId": 143,
                            "shortName": "FM  ",
                            "countryName": "Micronesia",
                            "phoneCode": "691"
                        },
                        {
                            "countryId": 144,
                            "shortName": "MD  ",
                            "countryName": "Moldova",
                            "phoneCode": "373"
                        },
                        {
                            "countryId": 145,
                            "shortName": "MC  ",
                            "countryName": "Monaco",
                            "phoneCode": "377"
                        },
                        {
                            "countryId": 146,
                            "shortName": "MN  ",
                            "countryName": "Mongolia",
                            "phoneCode": "976"
                        },
                        {
                            "countryId": 147,
                            "shortName": "MS  ",
                            "countryName": "Montserrat",
                            "phoneCode": "1664"
                        },
                        {
                            "countryId": 148,
                            "shortName": "MA  ",
                            "countryName": "Morocco",
                            "phoneCode": "212"
                        },
                        {
                            "countryId": 149,
                            "shortName": "MZ  ",
                            "countryName": "Mozambique",
                            "phoneCode": "258"
                        },
                        {
                            "countryId": 150,
                            "shortName": "MM  ",
                            "countryName": "Myanmar",
                            "phoneCode": "95"
                        },
                        {
                            "countryId": 151,
                            "shortName": "NA  ",
                            "countryName": "Namibia",
                            "phoneCode": "264"
                        },
                        {
                            "countryId": 152,
                            "shortName": "NR  ",
                            "countryName": "Nauru",
                            "phoneCode": "674"
                        },
                        {
                            "countryId": 153,
                            "shortName": "NP  ",
                            "countryName": "Nepal",
                            "phoneCode": "977"
                        },
                        {
                            "countryId": 154,
                            "shortName": "AN  ",
                            "countryName": "Netherlands Antilles",
                            "phoneCode": "599"
                        },
                        {
                            "countryId": 155,
                            "shortName": "NL  ",
                            "countryName": "Netherlands The",
                            "phoneCode": "31"
                        },
                        {
                            "countryId": 156,
                            "shortName": "NC  ",
                            "countryName": "New Caledonia",
                            "phoneCode": "687"
                        },
                        {
                            "countryId": 157,
                            "shortName": "NZ  ",
                            "countryName": "New Zealand",
                            "phoneCode": "64"
                        },
                        {
                            "countryId": 158,
                            "shortName": "NI  ",
                            "countryName": "Nicaragua",
                            "phoneCode": "505"
                        },
                        {
                            "countryId": 159,
                            "shortName": "NE  ",
                            "countryName": "Niger",
                            "phoneCode": "227"
                        },
                        {
                            "countryId": 160,
                            "shortName": "NG  ",
                            "countryName": "Nigeria",
                            "phoneCode": "234"
                        },
                        {
                            "countryId": 161,
                            "shortName": "NU  ",
                            "countryName": "Niue",
                            "phoneCode": "683"
                        },
                        {
                            "countryId": 162,
                            "shortName": "NF  ",
                            "countryName": "Norfolk Island",
                            "phoneCode": "672"
                        },
                        {
                            "countryId": 163,
                            "shortName": "MP  ",
                            "countryName": "Northern Mariana Islands",
                            "phoneCode": "1670"
                        },
                        {
                            "countryId": 164,
                            "shortName": "NO  ",
                            "countryName": "Norway",
                            "phoneCode": "47"
                        },
                        {
                            "countryId": 165,
                            "shortName": "OM  ",
                            "countryName": "Oman",
                            "phoneCode": "968"
                        },
                        {
                            "countryId": 166,
                            "shortName": "PK  ",
                            "countryName": "Pakistan",
                            "phoneCode": "92"
                        },
                        {
                            "countryId": 167,
                            "shortName": "PW  ",
                            "countryName": "Palau",
                            "phoneCode": "680"
                        },
                        {
                            "countryId": 168,
                            "shortName": "PS  ",
                            "countryName": "Palestinian Territory Occupied",
                            "phoneCode": "970"
                        },
                        {
                            "countryId": 169,
                            "shortName": "PA  ",
                            "countryName": "Panama",
                            "phoneCode": "507"
                        },
                        {
                            "countryId": 170,
                            "shortName": "PG  ",
                            "countryName": "Papua new Guinea",
                            "phoneCode": "675"
                        },
                        {
                            "countryId": 171,
                            "shortName": "PY  ",
                            "countryName": "Paraguay",
                            "phoneCode": "595"
                        },
                        {
                            "countryId": 172,
                            "shortName": "PE  ",
                            "countryName": "Peru",
                            "phoneCode": "51"
                        },
                        {
                            "countryId": 173,
                            "shortName": "PH  ",
                            "countryName": "Philippines",
                            "phoneCode": "63"
                        },
                        {
                            "countryId": 174,
                            "shortName": "PN  ",
                            "countryName": "Pitcairn Island",
                            "phoneCode": "0"
                        },
                        {
                            "countryId": 175,
                            "shortName": "PL  ",
                            "countryName": "Poland",
                            "phoneCode": "48"
                        },
                        {
                            "countryId": 176,
                            "shortName": "PT  ",
                            "countryName": "Portugal",
                            "phoneCode": "351"
                        },
                        {
                            "countryId": 177,
                            "shortName": "PR  ",
                            "countryName": "Puerto Rico",
                            "phoneCode": "1787"
                        },
                        {
                            "countryId": 178,
                            "shortName": "QA  ",
                            "countryName": "Qatar",
                            "phoneCode": "974"
                        },
                        {
                            "countryId": 179,
                            "shortName": "RE  ",
                            "countryName": "Reunion",
                            "phoneCode": "262"
                        },
                        {
                            "countryId": 180,
                            "shortName": "RO  ",
                            "countryName": "Romania",
                            "phoneCode": "40"
                        },
                        {
                            "countryId": 181,
                            "shortName": "RU  ",
                            "countryName": "Russia",
                            "phoneCode": "70"
                        },
                        {
                            "countryId": 182,
                            "shortName": "RW  ",
                            "countryName": "Rwanda",
                            "phoneCode": "250"
                        },
                        {
                            "countryId": 183,
                            "shortName": "SH  ",
                            "countryName": "Saint Helena",
                            "phoneCode": "290"
                        },
                        {
                            "countryId": 184,
                            "shortName": "KN  ",
                            "countryName": "Saint Kitts And Nevis",
                            "phoneCode": "1869"
                        },
                        {
                            "countryId": 185,
                            "shortName": "LC  ",
                            "countryName": "Saint Lucia",
                            "phoneCode": "1758"
                        },
                        {
                            "countryId": 186,
                            "shortName": "PM  ",
                            "countryName": "Saint Pierre and Miquelon",
                            "phoneCode": "508"
                        },
                        {
                            "countryId": 187,
                            "shortName": "VC  ",
                            "countryName": "Saint Vincent And The Grenadines",
                            "phoneCode": "1784"
                        },
                        {
                            "countryId": 188,
                            "shortName": "WS  ",
                            "countryName": "Samoa",
                            "phoneCode": "684"
                        },
                        {
                            "countryId": 189,
                            "shortName": "SM  ",
                            "countryName": "San Marino",
                            "phoneCode": "378"
                        },
                        {
                            "countryId": 190,
                            "shortName": "ST  ",
                            "countryName": "Sao Tome and Principe",
                            "phoneCode": "239"
                        },
                        {
                            "countryId": 191,
                            "shortName": "SA  ",
                            "countryName": "Saudi Arabia",
                            "phoneCode": "966"
                        },
                        {
                            "countryId": 192,
                            "shortName": "SN  ",
                            "countryName": "Senegal",
                            "phoneCode": "221"
                        },
                        {
                            "countryId": 193,
                            "shortName": "RS  ",
                            "countryName": "Serbia",
                            "phoneCode": "381"
                        },
                        {
                            "countryId": 194,
                            "shortName": "SC  ",
                            "countryName": "Seychelles",
                            "phoneCode": "248"
                        },
                        {
                            "countryId": 195,
                            "shortName": "SL  ",
                            "countryName": "Sierra Leone",
                            "phoneCode": "232"
                        },
                        {
                            "countryId": 196,
                            "shortName": "SG  ",
                            "countryName": "Singapore",
                            "phoneCode": "65"
                        },
                        {
                            "countryId": 197,
                            "shortName": "SK  ",
                            "countryName": "Slovakia",
                            "phoneCode": "421"
                        },
                        {
                            "countryId": 198,
                            "shortName": "SI  ",
                            "countryName": "Slovenia",
                            "phoneCode": "386"
                        },
                        {
                            "countryId": 199,
                            "shortName": "XG  ",
                            "countryName": "Smaller Territories of the UK",
                            "phoneCode": "44"
                        },
                        {
                            "countryId": 200,
                            "shortName": "SB  ",
                            "countryName": "Solomon Islands",
                            "phoneCode": "677"
                        },
                        {
                            "countryId": 201,
                            "shortName": "SO  ",
                            "countryName": "Somalia",
                            "phoneCode": "252"
                        },
                        {
                            "countryId": 202,
                            "shortName": "ZA  ",
                            "countryName": "South Africa",
                            "phoneCode": "27"
                        },
                        {
                            "countryId": 203,
                            "shortName": "GS  ",
                            "countryName": "South Georgia",
                            "phoneCode": "0"
                        },
                        {
                            "countryId": 204,
                            "shortName": "SS  ",
                            "countryName": "South Sudan",
                            "phoneCode": "211"
                        },
                        {
                            "countryId": 205,
                            "shortName": "ES  ",
                            "countryName": "Spain",
                            "phoneCode": "34"
                        },
                        {
                            "countryId": 206,
                            "shortName": "LK  ",
                            "countryName": "Sri Lanka",
                            "phoneCode": "94"
                        },
                        {
                            "countryId": 207,
                            "shortName": "SD  ",
                            "countryName": "Sudan",
                            "phoneCode": "249"
                        },
                        {
                            "countryId": 208,
                            "shortName": "SR  ",
                            "countryName": "Suriname",
                            "phoneCode": "597"
                        },
                        {
                            "countryId": 209,
                            "shortName": "SJ  ",
                            "countryName": "Svalbard And Jan Mayen Islands",
                            "phoneCode": "47"
                        },
                        {
                            "countryId": 210,
                            "shortName": "SZ  ",
                            "countryName": "Swaziland",
                            "phoneCode": "268"
                        },
                        {
                            "countryId": 211,
                            "shortName": "SE  ",
                            "countryName": "Sweden",
                            "phoneCode": "46"
                        },
                        {
                            "countryId": 212,
                            "shortName": "CH  ",
                            "countryName": "Switzerland",
                            "phoneCode": "41"
                        },
                        {
                            "countryId": 213,
                            "shortName": "SY  ",
                            "countryName": "Syria",
                            "phoneCode": "963"
                        },
                        {
                            "countryId": 214,
                            "shortName": "TW  ",
                            "countryName": "Taiwan",
                            "phoneCode": "886"
                        },
                        {
                            "countryId": 215,
                            "shortName": "TJ  ",
                            "countryName": "Tajikistan",
                            "phoneCode": "992"
                        },
                        {
                            "countryId": 216,
                            "shortName": "TZ  ",
                            "countryName": "Tanzania",
                            "phoneCode": "255"
                        },
                        {
                            "countryId": 217,
                            "shortName": "TH  ",
                            "countryName": "Thailand",
                            "phoneCode": "66"
                        },
                        {
                            "countryId": 218,
                            "shortName": "TG  ",
                            "countryName": "Togo",
                            "phoneCode": "228"
                        },
                        {
                            "countryId": 219,
                            "shortName": "TK  ",
                            "countryName": "Tokelau",
                            "phoneCode": "690"
                        },
                        {
                            "countryId": 220,
                            "shortName": "TO  ",
                            "countryName": "Tonga",
                            "phoneCode": "676"
                        },
                        {
                            "countryId": 221,
                            "shortName": "TT  ",
                            "countryName": "Trinidad And Tobago",
                            "phoneCode": "1868"
                        },
                        {
                            "countryId": 222,
                            "shortName": "TN  ",
                            "countryName": "Tunisia",
                            "phoneCode": "216"
                        },
                        {
                            "countryId": 223,
                            "shortName": "TR  ",
                            "countryName": "Turkey",
                            "phoneCode": "90"
                        },
                        {
                            "countryId": 224,
                            "shortName": "TM  ",
                            "countryName": "Turkmenistan",
                            "phoneCode": "7370"
                        },
                        {
                            "countryId": 225,
                            "shortName": "TC  ",
                            "countryName": "Turks And Caicos Islands",
                            "phoneCode": "1649"
                        },
                        {
                            "countryId": 226,
                            "shortName": "TV  ",
                            "countryName": "Tuvalu",
                            "phoneCode": "688"
                        },
                        {
                            "countryId": 227,
                            "shortName": "UG  ",
                            "countryName": "Uganda",
                            "phoneCode": "256"
                        },
                        {
                            "countryId": 228,
                            "shortName": "UA  ",
                            "countryName": "Ukraine",
                            "phoneCode": "380"
                        },
                        {
                            "countryId": 229,
                            "shortName": "AE  ",
                            "countryName": "United Arab Emirates",
                            "phoneCode": "971"
                        },
                        {
                            "countryId": 230,
                            "shortName": "GB  ",
                            "countryName": "United Kingdom",
                            "phoneCode": "44"
                        },
                        {
                            "countryId": 231,
                            "shortName": "US  ",
                            "countryName": "United States",
                            "phoneCode": "1"
                        },
                        {
                            "countryId": 232,
                            "shortName": "UM  ",
                            "countryName": "United States Minor Outlying Islands",
                            "phoneCode": "1"
                        },
                        {
                            "countryId": 233,
                            "shortName": "UY  ",
                            "countryName": "Uruguay",
                            "phoneCode": "598"
                        },
                        {
                            "countryId": 234,
                            "shortName": "UZ  ",
                            "countryName": "Uzbekistan",
                            "phoneCode": "998"
                        },
                        {
                            "countryId": 235,
                            "shortName": "VU  ",
                            "countryName": "Vanuatu",
                            "phoneCode": "678"
                        },
                        {
                            "countryId": 236,
                            "shortName": "VA  ",
                            "countryName": "Vatican City State (Holy See)",
                            "phoneCode": "39"
                        },
                        {
                            "countryId": 237,
                            "shortName": "VE  ",
                            "countryName": "Venezuela",
                            "phoneCode": "58"
                        },
                        {
                            "countryId": 238,
                            "shortName": "VN  ",
                            "countryName": "Vietnam",
                            "phoneCode": "84"
                        },
                        {
                            "countryId": 239,
                            "shortName": "VG  ",
                            "countryName": "Virgin IslandsS(British)",
                            "phoneCode": "1284"
                        },
                        {
                            "countryId": 240,
                            "shortName": "VI  ",
                            "countryName": "Virgin Islands (US)",
                            "phoneCode": "1340"
                        },
                        {
                            "countryId": 241,
                            "shortName": "WF  ",
                            "countryName": "Wallis And Futuna Islands",
                            "phoneCode": "681"
                        },
                        {
                            "countryId": 242,
                            "shortName": "EH  ",
                            "countryName": "Western Sahara",
                            "phoneCode": "212"
                        },
                        {
                            "countryId": 243,
                            "shortName": "YE  ",
                            "countryName": "Yemen",
                            "phoneCode": "967"
                        },
                        {
                            "countryId": 244,
                            "shortName": "YU  ",
                            "countryName": "Yugoslavia",
                            "phoneCode": "38"
                        },
                        {
                            "countryId": 245,
                            "shortName": "ZM  ",
                            "countryName": "Zambia",
                            "phoneCode": "260"
                        },
                        {
                            "countryId": 246,
                            "shortName": "ZW  ",
                            "countryName": "Zimbabwe",
                            "phoneCode": "263"
                        }
                    ]
                }
                const data = response;
                const formattedCountries = data.countries
                    .map((country) => ({
                        id: country.countryId,
                        name: country.countryName?.trim() ?? "",
                        code: country.shortName?.trim() ?? "",
                        dialCode: "+" + country.phoneCode ?? "",
                    }))
                    .sort((a, b) => a.name.localeCompare(b.name));

                setCountries(formattedCountries);
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        };

        fetchCountries();
    }, []);


    // Calculate total amount whenever individual amounts change
    useEffect(() => {
        let total = 0;

        if (isGroupEvent) {
            groupMembers.forEach(member => {
                if (member.amount) {
                    total += member.amount;
                }
            });
        } else {
            if (formData.amount) {
                total += formData.amount;
            }
        }

        setTotalAmount(total);
    }, [formData.amount, groupMembers, isGroupEvent]);

    // ============================
    // HANDLE SWITCHING BETWEEN GROUP/INDIVIDUAL MODES
    // ============================
    useEffect(() => {
        if (isGroupEvent) {
            if (!isGroupPayment) {
                // Switching to INDIVIDUAL mode

                // Store the original group data before switching if we haven't already
                if (groupMembers.length > 1 && !originalGroupData) {
                    setOriginalGroupData([...groupMembers]);
                }

                // Individual mode - keep only first member
                setGroupMembers(prev => {
                    const firstMember = prev[0];
                    return [{
                        ...firstMember,
                        // Keep the first member's data
                    }];
                });

            } else {
                // Check if we have stored original group data
                if (originalGroupData && originalGroupData.length > 1) {
                    // Restore the original group data
                    setGroupMembers(originalGroupData);
                    setOriginalGroupData(null); // Clear the stored data
                } else {
                    // No original data, just ensure we have at least one member
                    setGroupMembers(prev => {
                        if (prev.length === 0) {
                            return [{
                                id: 1,
                                fullName: '',
                                email: '',
                                phone: '',
                                role: '',
                                gender: '',
                                participantId: '',
                                Ins_Name: '',
                                Ins_Address: '',
                                State: '',
                                District: '',
                                PinCode: '',
                                Prefix: '',
                                Comments: '',
                                amount: 0,
                                fetchingAmount: false,
                                phoneVerified: false,
                                emailVerified: false,
                                verificationStep: 'phone',
                                isExistingUser: false,
                                autoFilled: false,
                                hasCheckedExistingUser: false,
                                photoFile: null,
                                photoPreview: null,
                                amountDetails: null
                            }];
                        }
                        return prev;
                    });
                }
            }
        }
    }, [isGroupPayment, isGroupEvent, maxMembers]);

    // ============================
    // FETCH AMOUNTS FOR GROUP MEMBERS WHEN PARTICIPANT ID CHANGES
    // ============================
    useEffect(() => {
        if (!isGroupEvent || !eventId) return;

        const fetchMissingAmounts = async () => {
            // Create an array of promises for members that need amount fetching
            const fetchPromises = groupMembers.map(async (member) => {
                // Skip if no participantId, already has amount, already paid, or already fetching
                if (!member.participantId ||
                    member.amount > 0 ||
                    member.isAlreadyPaid ||
                    member.fetchingAmount) {
                    return;
                }

                // Set fetching state
                setGroupMembers(prev => prev.map(m =>
                    m.id === member.id ? { ...m, fetchingAmount: true } : m
                ));

                try {
                    const response = await getData(`Event/GetAmount?eventId=${eventId}&participantTypeId=${member.participantId}`);

                    if (response && response.isError === false && response.result) {
                        const result = response.result;
                        const totalAmount = parseFloat(result.TotAmt) || 0;

                        setGroupMembers(prev => prev.map(m =>
                            m.id === member.id ? {
                                ...m,
                                amount: totalAmount,
                                amountDetails: {
                                    gstPercentage: parseFloat(result.Gst_Per) || 0,
                                    amountWithoutGst: parseFloat(result.WithOutGstAmt) || 0,
                                    gstAmount: parseFloat(result.Gst_Amt) || 0,
                                    totalAmount: totalAmount
                                },
                                fetchingAmount: false
                            } : m
                        ));

                    }
                } catch (error) {
                    console.error(`Error fetching amount for member ${member.id}:`, error);
                    setGroupMembers(prev => prev.map(m =>
                        m.id === member.id ? { ...m, fetchingAmount: false } : m
                    ));
                }
            });

            await Promise.all(fetchPromises);
        };

        fetchMissingAmounts();
    }, [groupMembers.map(m => `${m.id}-${m.phoneVerified}-${m.emailVerified}-${m.verificationStep}`).join(',')]);

    // Timer for OTP resend
    useEffect(() => {
        let timer;
        if (otpResendTimer > 0) {
            timer = setTimeout(() => setOtpResendTimer(otpResendTimer - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [otpResendTimer]);

    // Timer for OTP resend
    useEffect(() => {
        let timer;
        if (otpResendTimer > 0) {
            timer = setTimeout(() => setOtpResendTimer(otpResendTimer - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [otpResendTimer]);

    // Initialize OTP input refs
    useEffect(() => {
        otpInputRefs.current = otpInputRefs.current.slice(0, 6);
    }, []);

    // ============================
    // PAYMENT CALLBACK HANDLING
    // ============================
    useEffect(() => {
        // Check if we're coming from payment callback
        const urlParams = new URLSearchParams(location.search);
        const status = urlParams.get('STATUS');
        const orderId = urlParams.get('ORDERID');

        if (status || orderId) {
            const callbackData = {
                orderId: orderId || urlParams.get('ORDERID'),
                status: status || urlParams.get('STATUS'),
                transactionId: urlParams.get('TXNID'),
                amount: urlParams.get('TXNAMOUNT'),
                responseCode: urlParams.get('RESPCODE'),
                responseMsg: urlParams.get('RESPMSG'),
                bankTxnId: urlParams.get('BANKTXNID'),
                paymentMode: urlParams.get('PAYMENTMODE'),
                bankName: urlParams.get('BANKNAME'),
                gatewayName: urlParams.get('GATEWAYNAME'),
                callbackParams: Object.fromEntries(urlParams.entries()),
                timestamp: new Date().toISOString()
            };

            // Store in session storage
            sessionStorage.setItem('paymentResult', JSON.stringify(callbackData));

            // Get registration data
            const regData = sessionStorage.getItem('currentPaymentData') ||
                localStorage.getItem('eventPaymentData');

            if (regData) {
                sessionStorage.setItem('currentPaymentData', regData);
            }

            // Clear any previous stored callback data
            sessionStorage.removeItem('paytmCallbackData');

            // Redirect to payment status page
            navigate('/payment/status', {
                state: { paymentResult: callbackData },
                replace: true
            });
        }
    }, [location, navigate]);
    // Fetch participant types from API
    useEffect(() => {
        const fetchParticipantTypes = async () => {
            if (!event) return;

            try {
                setLoadingParticipantTypes(true);

                let apiUrl = '';

                if (hasSubEvents) {
                    apiUrl = `Dropdown/GetSubEventParticipantType/${eventId}`;
                } else {
                    apiUrl = `Dropdown/GetParticipants/${eventId}`;
                }

                const response = await getData(apiUrl);

                if (response && !response.isError) {
                    const rawData = response.data || response.Result || response.result || [];
                    const normalizedData = rawData.map(item => ({
                        Participant_ID:
                            item.Participant_ID ??
                            item.SubEventId ??
                            item.ParticipantId ??
                            0,

                        Participant_Name:
                            item.Participant_Name ??
                            item.Participant_Type ??
                            item.Name ??
                            ""
                    }));
                    setParticipantTypes(normalizedData);
                }
            } catch (error) {
                console.error('Error fetching participant types:', error);
            } finally {
                setLoadingParticipantTypes(false);
            }
        };

        fetchParticipantTypes();
    }, [event, hasSubEvents]);

    // Fetch event details from API
    useEffect(() => {
        const fetchEventDetails = async () => {
            try {
                const response = await getData(`Event/GetRegEventDetails/${eventId}`);

                if (response && response.IsError === false && response.Result) {
                    const result = response.Result;
                    setHasSubEvents(result.HasSubEvents === 1);
                    const eventData = {
                        Event_Id: eventId,
                        Event_Name: result.Event_Name || 'Event',
                        Start_datetime: result.Start_datetime,
                        Venue_Location: result.Event_Place || 'Venue not specified',
                        Event_orgNum: result.Mobile_No,
                        INST_NAME: result.INST_NAME,
                        organizer_name: result.organizer_name,
                        IsPaidEvent: result.Is_Paid_Event === "YES",
                        LogoUrl: result.LogoUrl,
                        EventMode: result.EventMode,
                        SubEvent: result.Is_Sub_Event
                    };

                    if (result.Is_Group_Event == "YES") {
                        eventData.Group_Event = true;
                        eventData.Max_Members = result.Max_Participant || 5;
                        setIsGroupEvent(true);
                        setMaxMembers(result.Max_Participant || 5);
                    } else {
                        eventData.Is_Group_Event = false;
                        setIsGroupEvent(false);
                    }

                    setEvent(eventData);
                } else {
                    Swal.fire({
                        title: 'Event Not Found',
                        text: response?.Message || 'The event you are looking for does not exist.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    }).then(() => {
                        navigate('/events');
                    });
                }
            } catch (error) {
                console.error('Error fetching event:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'Failed to load event details. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                }).then(() => {
                    navigate('/events');
                });
            } finally {
                setLoading(false);
            }
        };

        if (eventId) {
            fetchEventDetails();
        }
    }, [eventId, navigate]);

    // Scroll to top when registration step changes
    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
        }
    }, [registrationStep]);

    const fetchSubEvents = async (participantTypeId) => {
        if (!eventId || !participantTypeId) return;

        try {
            setLoadingSubEvents(true);

            const response = await getData(
                `Event/GetSubEvent_For_RegForm?subUrl=${eventId}&participantTypeId=${participantTypeId}`
            );
            if (response && response.isError === false) {
                setSubEvents(response.result || []);
            } else {
                setSubEvents([]);
            }
        } catch (error) {
            console.error("Error fetching sub events:", error);
            setSubEvents([]);
        } finally {
            setLoadingSubEvents(false);
        }
    };
    // Add this function to handle phone input blur
    const handlePhoneBlur = async (memberId, phoneNumber) => {
        if (!phoneNumber || phoneNumber.length === 0) return;

        // For international numbers (shorter than 10 digits or with country code)
        if (phoneNumber.length < 10 && phoneNumber.length > 0) {
            // Don't check for international numbers as they might be valid with country code
            return;
        }

        // Check if this is a paid member (only for 10-digit numbers)
        if (phoneNumber.length === 10) {
            const isPaid = await checkMemberPaidStatus(phoneNumber);

            if (isPaid && memberId) {
                // Clear the phone field
                handleGroupMemberChange({
                    target: {
                        name: 'phone',
                        value: ''
                    }
                }, memberId);
                return;
            }
        }
    };
    const fetchAmountForParticipant = async (participantTypeId, memberId = null) => {
        if (!eventId || !participantTypeId) {
            if (memberId) {
                setGroupMembers(prev => prev.map(member =>
                    member.id === memberId
                        ? { ...member, amount: 0, fetchingAmount: false }
                        : member
                ));
            } else if (!isGroupEvent) {
                setFormData(prev => ({ ...prev, amount: 0 }));
            }
            return;
        }

        if (memberId) {
            setGroupMembers(prev => prev.map(member =>
                member.id === memberId
                    ? { ...member, fetchingAmount: true }
                    : member
            ));
        }

        try {
            const response = await getData(`Event/GetAmount?eventId=${eventId}&participantTypeId=${participantTypeId}`);

            if (response && response.isError === false && response.result) {
                const result = response.result;
                // Ensure we have valid numbers, default to 0 if NaN
                const amountData = {
                    gstPercentage: parseFloat(result.Gst_Per) || 0,
                    amountWithoutGst: parseFloat(result.WithOutGstAmt) || 0,
                    gstAmount: parseFloat(result.Gst_Amt) || 0,
                    totalAmount: parseFloat(result.TotAmt) || 0
                };

                if (memberId) {
                    setGroupMembers(prev => prev.map(member =>
                        member.id === memberId
                            ? {
                                ...member,
                                amount: amountData.totalAmount,
                                amountDetails: amountData,
                                fetchingAmount: false
                            }
                            : member
                    ));
                } else if (!isGroupEvent) {
                    setFormData(prev => ({
                        ...prev,
                        amount: amountData.totalAmount,
                        amountDetails: amountData
                    }));
                }
            } else {
                console.error('Failed to fetch amount:', response);
                if (memberId) {
                    setGroupMembers(prev => prev.map(member =>
                        member.id === memberId
                            ? { ...member, fetchingAmount: false, amount: 0 }
                            : member
                    ));
                }
            }
        } catch (error) {
            console.error('Error fetching amount:', error);
            if (memberId) {
                setGroupMembers(prev => prev.map(member =>
                    member.id === memberId
                        ? { ...member, fetchingAmount: false, amount: 0 }
                        : member
                ));
            }
        }
    };

    const checkExistingUser = async (phoneNumber) => {
        if (!phoneNumber || phoneNumber.length !== 10) {
            return null;
        }

        try {
            const response = await getData(`Event/GetRegDetail/${phoneNumber}?eventid=${eventId}`);

            if (response && response.isError === false && response.result && response.result.length > 0) {
                const registration = response.result[0];

                // Process based on event type and current mode
                if (isGroupEvent && isGroupPayment) {
                    // GROUP EVENT WITH GROUP PAYMENT ENABLED - Handle main member + group members
                    return processGroupEventData(registration);
                } else if (isGroupEvent && !isGroupPayment) {
                    // GROUP EVENT WITH INDIVIDUAL PAYMENT - Handle as individual
                    return processIndividualEventData(registration);
                } else if (hasSubEvents) {
                    // SUB EVENT - Handle with sub-event selections
                    return processSubEventData(registration);
                } else {
                    // INDIVIDUAL EVENT - Handle single member
                    return processIndividualEventData(registration);
                }
            }
            return null;
        } catch (error) {
            console.error('Error checking existing user:', error);
            return null;
        }
    };

    // Process INDIVIDUAL EVENT data
    const processIndividualEventData = (registration) => {
        // Get participant type from EventDetails
        const participantTypeId = registration.EventDetails && registration.EventDetails[0]
            ? registration.EventDetails[0].Participant_type
            : registration.Participant_type;
      console.log("participantTypes",participantTypes);
        // Find participant type name
        const participantType = participantTypes.find(
            p => p.Participant_ID === parseInt(participantTypeId)
        );
        console.log("participantType",participantType);
        // Check if MAIN registration is paid (Paid_status at root level)
        const isMainRegistrationPaid = registration.Paid_status === 1;

        // Get paid sub-events (where Paid_status === 1 in EventDetails)
        const paidSubEvents = registration.EventDetails
            ? registration.EventDetails
                .filter(detail => detail.Paid_status === 1 && detail.SubEvent_Id)
                .map(detail => detail.SubEvent_Id)
            : [];

        // Check if ALL sub-events for this participant type are paid
        const allSubEventsPaid = registration.EventDetails && registration.EventDetails.length > 0
            ? registration.EventDetails.every(detail => detail.Paid_status === 1)
            : false;

        const individualData = {
            fullName: registration.Name || '',
            email: registration.Email || '',
            phone: registration.Phone || '',
            gender: registration.Gender || '',
            role: participantType ? participantType.Participant_Name : '',
            participantId: participantTypeId,
            Prefix: registration.prefix ? registration.prefix.trim() : '',
            Ins_Name: registration.Inst_Name || '',
            Ins_Address: registration.Ins_Address || '',
            State: registration.State || '',
            District: registration.District ? registration.District.trim() : '',
            PinCode: registration.Pincode || '',
            Comments: registration.Comments || '',
            photoPreview: registration.PhotoPath_Url || null,
            phoneVerified: true,
            emailVerified: true,
            verificationStep: 'details',
            isExistingUser: true,
            autoFilled: true,
            hasCheckedExistingUser: true,

            // Main registration payment status
            isMainRegistrationPaid: isMainRegistrationPaid,
            mainPaidStatus: registration.Paid_status || 0,

            // Sub-event payment information
            paidSubEvents: paidSubEvents,
            allSubEventsPaid: allSubEventsPaid,
            eventDetails: registration.EventDetails || [],

            amount: 0,
            amountDetails: null
        };
  
        return {
            type: 'individual',
            data: individualData,
            registration: registration
        };
    };

    const processGroupEventData = (registration) => {
        // Process main member
        const mainParticipantTypeId = registration.EventDetails && registration.EventDetails[0]
            ? registration.EventDetails[0].Participant_type
            : registration.Participant_type;

        const mainParticipantType = participantTypes.find(
            p => p.Participant_ID === parseInt(mainParticipantTypeId)
        );

        // Store which participant type is paid for main member
        const mainPaidParticipantTypeId = registration.Paid_status === 1 ? mainParticipantTypeId : null;

        const allMembers = [];

        // Add main member
        allMembers.push({
            id: 1, // This will be overwritten when mapping to existing members
            fullName: registration.Name || '',
            email: registration.Email || '',
            phone: registration.Phone || '',
            gender: registration.Gender || '',
            role: mainParticipantType ? mainParticipantType.Participant_Name : '',
            participantId: mainParticipantTypeId,
            Prefix: registration.prefix ? registration.prefix.trim() : '',
            Ins_Name: registration.Inst_Name || '',
            Ins_Address: registration.Ins_Address || '',
            State: registration.State || '',
            District: registration.District ? registration.District.trim() : '',
            PinCode: registration.Pincode || '',
            Comments: registration.Comments || '',
            photoPreview: registration.PhotoPath_Url || null,
            photoFile: null,
            amount: 0, // Don't set amount here, let the fetch function handle it
            fetchingAmount: false,
            phoneVerified: true,
            emailVerified: true,
            verificationStep: 'details',
            isExistingUser: true,
            autoFilled: true,
            hasCheckedExistingUser: true,
            paidStatus: registration.Paid_status || 0,
            isAlreadyPaid: registration.Paid_status === 1,
            paidParticipantTypeId: mainPaidParticipantTypeId,
            amountDetails: null
        });

        // Add group members if they exist
        if (registration.GroupDetails && Array.isArray(registration.GroupDetails)) {
            registration.GroupDetails.forEach((groupMember, index) => {
                const groupParticipantTypeId = groupMember.EventDetails && groupMember.EventDetails[0]
                    ? groupMember.EventDetails[0].Participant_type
                    : groupMember.Participant_type;

                const groupParticipantType = participantTypes.find(
                    p => p.Participant_ID === parseInt(groupParticipantTypeId)
                );

                // Store which participant type is paid for group member
                const groupPaidParticipantTypeId = groupMember.Paid_status === 1 ? groupParticipantTypeId : null;

                allMembers.push({
                    id: index + 2, // This will be overwritten when mapping
                    fullName: groupMember.Name || '',
                    email: groupMember.Email || '',
                    phone: groupMember.Phone || '',
                    gender: groupMember.Gender || '',
                    role: groupParticipantType ? groupParticipantType.Participant_Name : '',
                    participantId: groupParticipantTypeId,
                    Prefix: groupMember.prefix ? groupMember.prefix.trim() : '',
                    Ins_Name: groupMember.Inst_Name || '',
                    Ins_Address: groupMember.Ins_Address || '',
                    State: groupMember.State || '',
                    District: groupMember.District ? groupMember.District.trim() : '',
                    PinCode: groupMember.Pincode || '',
                    Comments: groupMember.Comments || '',
                    photoPreview: groupMember.PhotoPath_Url || null,
                    photoFile: null,
                    amount: 0, // Don't set amount here
                    fetchingAmount: false,
                    phoneVerified: true,
                    emailVerified: true,
                    verificationStep: 'details',
                    isExistingUser: true,
                    autoFilled: true,
                    hasCheckedExistingUser: true,
                    paidStatus: groupMember.Paid_status || 0,
                    isAlreadyPaid: groupMember.Paid_status === 1,
                    paidParticipantTypeId: groupPaidParticipantTypeId,
                    amountDetails: null
                });
            });
        }

        return {
            type: 'group',
            members: allMembers,
            memberCount: allMembers.length,
            registration: registration
        };
    };

    // Process SUB EVENT data
    const processSubEventData = (registration) => {
        // Get participant type
        const participantTypeId = registration.EventDetails && registration.EventDetails[0]
            ? registration.EventDetails[0].Participant_type
            : '';

        // Get all sub-event IDs
        const subEventIds = registration.EventDetails
            ? registration.EventDetails
                .filter(detail => detail.SubEvent_Id && detail.SubEvent_Id > 0)
                .map(detail => detail.SubEvent_Id)
            : [];

        // Find participant type name
        const participantType = participantTypes.find(
            p => p.Participant_ID === parseInt(participantTypeId)
        );

        const individualData = {
            fullName: registration.Name || '',
            email: registration.Email || '',
            phone: registration.Phone || '',
            gender: registration.Gender || '',
            role: participantType ? participantType.Participant_Name : '',
            participantId: participantTypeId,
            Prefix: registration.prefix ? registration.prefix.trim() : '',
            Ins_Name: registration.Inst_Name || '',
            Ins_Address: registration.Ins_Address || '',
            State: registration.State || '',
            District: registration.District ? registration.District.trim() : '',
            PinCode: registration.Pincode || '',
            Comments: registration.Comments || '',
            photoPreview: registration.PhotoPath_Url || null,
            phoneVerified: true,
            emailVerified: true,
            verificationStep: 'details',
            isExistingUser: true,
            autoFilled: true,
            hasCheckedExistingUser: true,
            paidStatus: registration.EventDetails && registration.EventDetails[0]
                ? registration.EventDetails[0].Paid_status : 0,
            isAlreadyPaid: registration.EventDetails && registration.EventDetails[0]
                ? registration.EventDetails[0].Paid_status === 1 : false,
            amount: 0,
            amountDetails: null
        };

        return {
            type: 'subevent',
            data: individualData,
            subEventIds: subEventIds,
            registration: registration
        };
    };
    const autoFillExistingUser = async (phoneNumber, isFromOtpVerification = false) => {
        if (!isFromOtpVerification && formData.hasCheckedExistingUser) {
            return false;
        }

        const userData = await checkExistingUser(phoneNumber);

        if (userData) {
            const user = userData.data;
            const registration = userData.registration;

            const participantType = participantTypes.find(
                p => p.Participant_ID === registration.Participant_type
            );

            const isThisTypePaid = registration.Paid_status === 1;
            const paidParticipantTypeId = isThisTypePaid ? registration.Participant_type : null;

            const updatedFormData = {
                fullName: user.fullName || '',
                email: user.email || '',
                phone: user.phone || '',
                role: participantType ? participantType.Participant_Name : '',
                gender: user.gender || '',
                participantId: registration.Participant_type || '',

                Prefix: registration.prefix?.trim() || '',
                Ins_Name: registration.Inst_Name || '',
                Ins_Address: registration.Ins_Address || '',
                State: registration.State || '',
                District: registration.District?.trim() || '',
                PinCode: registration.Pincode || '',
                Comments: registration.Comments || '',

                photoPreview: registration.PhotoPath_Url || null,

                amount: 0,
                phoneVerified: true,
                emailVerified: true,
                verificationStep: 'details',
                isExistingUser: true,
                autoFilled: true,
                hasCheckedExistingUser: true,

                paidStatus: registration.Paid_status,
                isAlreadyPaid: isThisTypePaid,
                paidParticipantTypeId: paidParticipantTypeId,
                eventDetails: registration.EventDetails || []
            };

            setFormData(updatedFormData);

            // If already paid, set amount to 0 and disable everything
            if (isThisTypePaid) {
                setFormData(prev => ({
                    ...prev,
                    amount: 0,
                    amountDetails: null,
                    // Mark that the form is locked for paid users
                    isFormLocked: true
                }));
            } else if (registration.Participant_type) {
                await fetchAmountForParticipant(registration.Participant_type);
                await fetchSubEvents(registration.Participant_type);
            }

            return true;
        }

        return false;
    };

    const fillAllGroupMembers = (userData) => {
        if (!userData || !userData.members || userData.members.length === 0) return;

        // Store the original group data
        setOriginalGroupData(userData.members);

        // Create a mapping of phone numbers to members from the API
        const apiMembersByPhone = {};
        userData.members.forEach(apiMember => {
            if (apiMember.phone) {
                apiMembersByPhone[apiMember.phone] = apiMember;
            }
        });

        // Update existing group members with API data
        setGroupMembers(prev => {
            const updatedMembers = prev.map(existingMember => {
                const matchingApiMember = apiMembersByPhone[existingMember.phone];

                if (matchingApiMember) {
                    return {
                        ...existingMember,
                        ...matchingApiMember,
                        phoneVerified: true,
                        emailVerified: true,
                        verificationStep: 'details',
                        isExistingUser: true,
                        autoFilled: true,
                        hasCheckedExistingUser: true,
                        amount: 0, // Reset to 0
                        amountDetails: null,
                        fetchingAmount: false, // Reset fetching state
                        photoFile: existingMember.photoFile || null,
                        photoPreview: matchingApiMember.photoPreview || existingMember.photoPreview || null,
                    };
                }
                return existingMember;
            });

            // Add new members from API
            const existingPhones = new Set(prev.map(m => m.phone));
            const newMembersFromApi = userData.members.filter(
                apiMember => !existingPhones.has(apiMember.phone) && apiMember.phone
            );

            if (newMembersFromApi.length > 0) {
                const maxId = Math.max(...prev.map(m => m.id), 0);
                newMembersFromApi.forEach((apiMember, index) => {
                    updatedMembers.push({
                        id: maxId + index + 1,
                        ...apiMember,
                        phoneVerified: true,
                        emailVerified: true,
                        verificationStep: 'details',
                        isExistingUser: true,
                        autoFilled: true,
                        hasCheckedExistingUser: true,
                        photoFile: null,
                        photoPreview: apiMember.photoPreview || null,
                        amount: 0,
                        fetchingAmount: false,
                        amountDetails: null
                    });
                });
            }

            return updatedMembers;
        });

        // Fetch amounts for all members
        setTimeout(() => {
            setGroupMembers(currentMembers => {
                currentMembers.forEach(member => {
                    if (member.participantId && !member.isAlreadyPaid) {
                        fetchAmountForParticipant(member.participantId, member.id);
                    }
                });
                return currentMembers;
            });
        }, 500);
    };

    const sendMobileOtp = async (phoneData, memberId = null) => {
        let fullPhoneNumber;
        let countryCode = '';
        let mobileNumber = '';

        if (typeof phoneData === 'object') {
            countryCode = phoneData.countryCode || '';
            mobileNumber = phoneData.mobileNumber || '';
            fullPhoneNumber = phoneData.fullNumber || (countryCode + mobileNumber);
        } else {
            fullPhoneNumber = phoneData;

            const match = fullPhoneNumber.match(/(\+\d+)\s*(\d+)/);

            if (match) {
                countryCode = match[1];
                mobileNumber = match[2];
            } else {
                const cleaned = fullPhoneNumber.toString().replace(/\D/g, '');

                if (cleaned.length > 10) {
                    countryCode = '+' + cleaned.substring(0, cleaned.length - 10);
                    mobileNumber = cleaned.substring(cleaned.length - 10);
                } else {
                    mobileNumber = cleaned;
                }
            }
        }

        const phoneStr = fullPhoneNumber.toString();
        let isIndianFormat = false;
        let indianMobileNumber = '';

        if (phoneStr.startsWith('+91')) {
            isIndianFormat = true;
            indianMobileNumber = phoneStr.replace(/[^0-9]/g, '').slice(-10);
        } else if (
            phoneStr.replace(/\D/g, '').startsWith('91') &&
            phoneStr.replace(/\D/g, '').length === 12
        ) {
            isIndianFormat = true;
            indianMobileNumber = phoneStr.replace(/[^0-9]/g, '').slice(-10);
        } else if (
            phoneStr.replace(/\D/g, '').startsWith('0') &&
            phoneStr.replace(/\D/g, '').length === 11
        ) {
            isIndianFormat = true;
            indianMobileNumber = phoneStr.replace(/[^0-9]/g, '').slice(-10);
        } else if (phoneStr.replace(/\D/g, '').length === 10) {
            isIndianFormat = true;
            indianMobileNumber = phoneStr.replace(/[^0-9]/g, '');
        }

        // Validate Indian mobile number length
        if (isIndianFormat) {
            if (!indianMobileNumber || indianMobileNumber.length !== 10) {
                Swal.fire({
                    title: 'Invalid Phone Number',
                    text: 'Please enter a valid 10-digit mobile number',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return false;
            }
        }

        setOtpSending(true);

        try {
            const phoneToSend = isIndianFormat
                ? indianMobileNumber
                : mobileNumber.replace(/\D/g, '');

            const payload = {
                Action: "SAVE_PHONE",
                Reg_ID: 0,
                Event_ID: eventId,
                Inst_id: 0,
                Event_type: 0,
                Div_id: 0,
                Group_Id: 0,
                Email: "",
                Phone: phoneToSend
            };

            const response = await postData(
                'Event/send-mobile-otp',
                payload
            );

            if (!response || response.IsError) {
                throw new Error(response?.Message || 'Failed to process phone number');
            }

            // ==========================
            // INDIAN NUMBERS -> SHOW OTP
            // ==========================
            if (isIndianFormat) {
                setOtpType('mobile');
                setCurrentContact(indianMobileNumber);
                setCurrentVerifyingMemberId(memberId);
                setOtpResendTimer(60);
                setOtp(['', '', '', '', '', '']);
                setShowOtpModal(true);

                Swal.fire({
                    title: 'OTP Sent!',
                    text: `OTP has been sent to ${indianMobileNumber}`,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });

                return true;
            }

            // ==================================
            // NON-INDIAN NUMBERS -> AUTO VERIFY
            // ==================================
            const targetMemberId = memberId || currentVerifyingMemberId;

            if (targetMemberId) {
                setGroupMembers(prev =>
                    prev.map(member =>
                        member.id === targetMemberId
                            ? {
                                ...member,
                                phoneVerified: true,
                                phone: mobileNumber,
                                countryCode,
                                verificationStep: 'email',
                                isExistingUser: false,
                                hasCheckedExistingUser: true
                            }
                            : member
                    )
                );
            } else {
                setFormData(prev => ({
                    ...prev,
                    phoneVerified: true,
                    phone: mobileNumber,
                    countryCode,
                    verificationStep: 'email',
                    isExistingUser: false,
                    hasCheckedExistingUser: true
                }));
            }

            await new Promise(resolve => setTimeout(resolve, 100));

            setRender(prev => !prev);
            setVerificationKey(prev => prev + 1);
            setCurrentVerifyingMemberId(null);

            Swal.fire({
                title: 'Phone Verified!',
                text: 'Phone number verified successfully.',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
            });

            return true;
        } catch (error) {
            console.error('Error sending OTP:', error);

            Swal.fire({
                title: isIndianFormat
                    ? 'Failed to Send OTP'
                    : 'Verification Failed',
                text: error.message || 'Please try again',
                icon: 'error',
                confirmButtonText: 'OK'
            });

            return false;
        } finally {
            setOtpSending(false);
        }
    };

    // Function to send Email OTP
    const sendEmailOtp = async (email, phone, memberId = null) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            Swal.fire({
                title: 'Invalid Email',
                text: 'Please enter a valid email address',
                icon: 'warning',
                confirmButtonText: 'OK',
                background: '#f8fafc',
                color: '#1f2937'
            });
            return false;
        }

        setOtpSending(true);
        try {
            const payload = {
                Action: "UPDATE_EMAIL",
                Reg_ID: 0,
                Event_ID: eventId,
                Inst_id: 0,
                Event_type: 0,
                Div_id: 0,
                Group_Id: 0,
                Email: email,
                Phone: phone
            };

            const response = await postData('Event/send-email-otp', payload);

            if (response && !response.IsError) {
                setOtpType('email');
                setCurrentContact(phone);
                setCurrentEmail(email);
                setCurrentVerifyingMemberId(memberId);
                setOtpResendTimer(60);
                setOtp(['', '', '', '', '', '']);
                setShowOtpModal(true);

                Swal.fire({
                    title: 'OTP Sent!',
                    text: `OTP has been sent to your email address`,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return true;
            } else {
                throw new Error(response?.Message || 'Failed to send email OTP');
            }
        } catch (error) {
            console.error('Error sending email OTP:', error);
            Swal.fire({
                title: 'Failed to Send OTP',
                text: error.message || 'Please try again',
                icon: 'error',
                confirmButtonText: 'OK',
                background: '#f8fafc',
                color: '#1f2937'
            });
            return false;
        } finally {
            setOtpSending(false);
        }
    };

    // Unified send OTP function (now only for email)
    const sendOtp = async (type, contact, phone = null, memberId = null) => {

        if (type === 'email') {
            if (!phone) {
                if (memberId) {
                    const member = groupMembers.find(m => m.id === memberId);
                    phone = member?.phone || '';
                } else {
                    phone = formData.phone;
                }
            }
            return await sendEmailOtp(contact, phone, memberId);
        }
        return false;
    };

    const verifyMobileOtp = async (enteredOtp) => {
        try {
            const response = await postData('Event/verify-mob-otp', {
                Reg_id: 0,
                Event_id: eventId,
                Otp: enteredOtp,
                Phone: currentContact,
                Email: ""
            });

            if (response.isError == false) {
                const userData = await checkExistingUser(currentContact);

                if (currentVerifyingMemberId) {
                    if (userData && userData.type === 'group') {
                        // Store the original group data
                        setOriginalGroupData(userData.members);

                        if (isGroupPayment) {
                            // GROUP REGISTRATION ENABLED - Bind ALL members
                            fillAllGroupMembers(userData);

                            Swal.fire({
                                title: 'Group Registration Found',
                                text: `Found ${userData.members.length} members. All group members have been auto-filled.`,
                                icon: 'success',
                                timer: 3000,
                                showConfirmButton: false
                            });
                        } else {
                            // GROUP REGISTRATION DISABLED - Bind ONLY the verified member
                            const matchedMember = userData.members.find(
                                m => m.phone === currentContact
                            );

                            if (matchedMember) {
                                setGroupMembers(prev => prev.map(member => {
                                    if (member.id === currentVerifyingMemberId) {
                                        return {
                                            ...member,
                                            ...matchedMember,
                                            phoneVerified: true,
                                            emailVerified: true,
                                            verificationStep: 'details',
                                            isExistingUser: true,
                                            autoFilled: true,
                                            hasCheckedExistingUser: true,
                                            amount: 0,
                                            amountDetails: null
                                        };
                                    }
                                    return member;
                                }));

                                if (matchedMember.participantId && !matchedMember.isAlreadyPaid) {
                                    setTimeout(() => {
                                        fetchAmountForParticipant(
                                            matchedMember.participantId,
                                            currentVerifyingMemberId
                                        );
                                    }, 300);
                                }

                                Swal.fire({
                                    title: 'Existing User Found',
                                    text: 'Member details have been auto-filled.',
                                    icon: 'success',
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            } else {
                                setGroupMembers(prev => prev.map(member => {
                                    if (member.id === currentVerifyingMemberId) {
                                        return {
                                            ...member,
                                            phoneVerified: true,
                                            verificationStep: 'email',
                                            isExistingUser: false,
                                            hasCheckedExistingUser: true
                                        };
                                    }
                                    return member;
                                }));
                            }
                        }
                    } else if (userData) {
                        // Individual registration
                        setGroupMembers(prev => prev.map(member => {
                            if (member.id === currentVerifyingMemberId) {
                                return {
                                    ...member,
                                    ...userData.data,
                                    phoneVerified: true,
                                    emailVerified: true,
                                    verificationStep: 'details',
                                    isExistingUser: true,
                                    autoFilled: true,
                                    hasCheckedExistingUser: true,
                                    amount: 0,
                                    amountDetails: null
                                };
                            }
                            return member;
                        }));

                        if (userData.registration.Participant_type &&
                            userData.registration.Paid_status !== 1) {
                            setTimeout(() => {
                                fetchAmountForParticipant(
                                    userData.registration.Participant_type,
                                    currentVerifyingMemberId
                                );
                            }, 300);
                        }
                    } else {
                        setGroupMembers(prev => prev.map(member => {
                            if (member.id === currentVerifyingMemberId) {
                                return {
                                    ...member,
                                    phoneVerified: true,
                                    verificationStep: 'email',
                                    isExistingUser: false,
                                    hasCheckedExistingUser: true
                                };
                            }
                            return member;
                        }));
                    }
                } else {
                    // Individual event handling
                    if (userData) {
                        await autoFillExistingUser(currentContact, true);
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            phoneVerified: true,
                            verificationStep: 'email',
                            isExistingUser: false,
                            hasCheckedExistingUser: true
                        }));
                    }
                }

                setShowOtpModal(false);
                return true;
            } else {
                Swal.fire({
                    title: 'Verification Failed',
                    text: 'Please try again',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                throw new Error(response?.message || 'Invalid OTP');
            }
        } catch (error) {
            console.error('Error verifying mobile OTP:', error);
            Swal.fire({
                title: 'Verification Failed',
                text: error.message || 'Please try again',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return false;
        } finally {
            setOtpVerifying(false);
        }
    };

    // Function to verify Email OTP
    const verifyEmailOtp = async (enteredOtp) => {
        try {
            const response = await postData('Event/verify-mail-otp', {
                Reg_id: 0,
                Event_id: eventId,
                Otp: enteredOtp,
                Phone: currentContact,
                Email: currentEmail
            });

            if (response.isError == false) {
                if (currentVerifyingMemberId) {
                    // Update the specific member's verification status
                    setGroupMembers(prev => prev.map(member => {
                        if (member.id === currentVerifyingMemberId) {
                            return {
                                ...member,
                                emailVerified: true,
                                verificationStep: 'details'
                            };
                        }
                        return member;
                    }));

                    // Force a re-render of the form
                    setRender(prev => !prev);
                } else {
                    setFormData(prev => ({
                        ...prev,
                        emailVerified: true,
                        verificationStep: 'details'
                    }));
                }

                setShowOtpModal(false);
                setVerificationKey(prev => prev + 1);

                Swal.fire({
                    title: 'Verification Successful!',
                    text: `Your email has been verified`,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return true;
            } else {
                Swal.fire({
                    title: 'Verification Failed',
                    text: response.message || 'Please try again',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                throw new Error(response?.message || 'Invalid OTP');
            }
        } catch (error) {
            console.error('Error verifying email OTP:', error);
            Swal.fire({
                title: 'Verification Failed',
                text: error.message || 'Please try again',
                icon: 'error',
                confirmButtonText: 'OK',
                background: '#f8fafc',
                color: '#1f2937'
            });
            return false;
        }
    };

    // Unified verify OTP function
    const verifyOtp = async () => {
        const enteredOtp = otp.join('');
        if (enteredOtp.length !== 6) {
            Swal.fire({
                title: 'Incomplete OTP',
                text: 'Please enter all 6 digits of the OTP',
                icon: 'warning',
                confirmButtonText: 'OK',
                background: '#f8fafc',
                color: '#1f2937'
            });
            return;
        }

        setOtpVerifying(true);
        try {
            if (otpType === 'mobile') {
                await verifyMobileOtp(enteredOtp);
            } else if (otpType === 'email') {
                await verifyEmailOtp(enteredOtp);
            }
        } finally {
            setOtpVerifying(false);
        }
    };

    // Handle OTP input change
    const handleOtpChange = (index, value) => {
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            otpInputRefs.current[index + 1]?.focus();
        }
    };

    // Auto-verify when all OTP digits are filled
    useEffect(() => {
        const allFilled = otp.every(digit => digit !== '');
        if (allFilled && otp.length === 6) {
            const timer = setTimeout(() => {
                verifyOtp();
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [otp]);

    // Handle OTP key down
    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            otpInputRefs.current[index - 1]?.focus();
        }
    };

    // Handle input change for individual form
    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'photoFile') {
            // Handle file upload
            const file = files[0];
            if (file) {
                // Check file type
                if (!file.type.startsWith('image/')) {
                    Swal.fire({
                        title: 'Invalid File',
                        text: 'Please select a valid image file (JPG, PNG, GIF)',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    });
                    return;
                }

                if (file.size > 512 * 1024) {
                    Swal.fire({
                        title: 'File Too Large',
                        text: 'File size should be less than 512 KB',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    });
                    return;
                }

                // Create preview
                const reader = new FileReader();
                reader.onloadend = () => {
                    setFormData(prev => ({
                        ...prev,
                        photoFile: file,
                        photoPreview: reader.result
                    }));
                };
                reader.readAsDataURL(file);
            }
            return;
        }
        if (name === 'phone') {
            const numericValue = value.replace(/\D/g, '');

            setFormData(prev => ({
                ...prev,
                [name]: numericValue,
                phoneVerified: false,
                emailVerified: false,
                verificationStep: 'phone',
                isExistingUser: false,
                autoFilled: false,
                hasCheckedExistingUser: false
            }));
        }
        else if (name === 'email') {
            if (!formData.phoneVerified && !formData.isExistingUser) {
                Swal.fire({
                    title: 'Phone Verification Required',
                    text: 'Please verify phone number first',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return;
            }

            setFormData(prev => ({
                ...prev,
                [name]: value,
                emailVerified: false,
                verificationStep: formData.phoneVerified ? 'email' : 'phone'
            }));
        }
        else if (name === 'role') {
            if (!formData.phoneVerified || !formData.emailVerified) {
                Swal.fire({
                    title: 'Verification Required',
                    text: 'Please verify phone and email first',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return;
            }

            const selectedParticipant = participantTypes.find(
                participant => participant.Participant_Name === value
            );

            const participantId = selectedParticipant ? selectedParticipant.Participant_ID : '';

            setFormData(prev => ({
                ...prev,
                [name]: value,
                participantId: participantId
            }));

            if (participantId) {
                if (!hasSubEvents) {
                    fetchAmountForParticipant(participantId);
                } else {
                    setFormData(prev => ({
                        ...prev,
                        amount: 0
                    }));
                    // THIS IS WHERE YOU NEED TO CLEAR selectedSubEvents
                    setSelectedSubEvents([]); // Make sure this is called
                    fetchSubEvents(participantId);
                }
            } else {
                setFormData(prev => ({ ...prev, amount: 0 }));
            }
        }
        else if (name === 'gender') {
            if (!formData.phoneVerified || !formData.emailVerified) {
                Swal.fire({
                    title: 'Verification Required',
                    text: 'Please verify phone and email first',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return;
            }

            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
        else {
            if (formData.verificationStep !== 'details') {
                Swal.fire({
                    title: 'Verification Required',
                    text: 'Please complete phone and email verification first',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return;
            }

            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const checkSubEventSlot = async (subEventId, participantTypeId) => {
        try {
            const response = await getData(`Event/SubEventSlotCheck?subUrl=${eventId}&subEventId=${subEventId}&participantTypeId=${participantTypeId}`);

            if (response && response.isError === true) {
                // Slot is full
                return {
                    available: false,
                    message: response.message || "This Sub Event Slot is Full",
                    slotsLeft: 0
                };
            } else if (response && response.isError === false && response.data) {
                // Slot available
                const availableSlots = response.data.AvailableSlots || 0;
                return {
                    available: true,
                    data: response.data,
                    message: response.message || "Slot available",
                    slotsLeft: availableSlots
                };
            } else {
                return {
                    available: false,
                    message: "Unable to check slot availability",
                    slotsLeft: 0
                };
            }
        } catch (error) {
            console.error('Error checking slot availability:', error);
            return {
                available: false,
                message: "Error checking slot availability",
                slotsLeft: 0
            };
        }
    };

    const handleSubEventSelection = async (subEventId, isChecked) => {
        // If we're trying to select a sub-event, check availability first
        if (isChecked) {
            // Get the participant type ID
            const participantTypeId = formData.participantId;

            if (!participantTypeId) {
                Swal.fire({
                    title: 'Participant Type Required',
                    text: 'Please select a participant type first',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return false; // Return false to indicate selection failed
            }

            // Check slot availability
            const slotCheck = await checkSubEventSlot(subEventId, participantTypeId);
            Swal.close();

            if (!slotCheck.available) {
                // ONLY show popup when slot is full
                await Swal.fire({
                    title: 'Slot Full',
                    text: slotCheck.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                return false; // Return false to indicate selection failed
            }

            // NO POPUP for available slots - just proceed silently
            // Add sub-event
            setSelectedSubEvents(prev => [...prev, subEventId]);

            // Update total amount if needed
            const subEvent = subEvents.find(s => s.SubEvent_Id === subEventId);
            if (subEvent && subEvent.TotAmt) {
                setFormData(prev => ({
                    ...prev,
                    amount: (prev.amount || 0) + subEvent.TotAmt
                }));
            }

            return true; // Return true to indicate selection succeeded
        } else {
            // Removing sub-event - no need to check availability
            setSelectedSubEvents(prev => prev.filter(id => id !== subEventId));

            // Update total amount
            const subEvent = subEvents.find(s => s.SubEvent_Id === subEventId);
            if (subEvent && subEvent.TotAmt) {
                setFormData(prev => ({
                    ...prev,
                    amount: Math.max(0, (prev.amount || 0) - subEvent.TotAmt)
                }));
            }

            return true; // Return true to indicate deselection succeeded
        }
    };

    const handleGroupMemberChange = (e, memberId) => {
        const { name, value, files } = e.target;
        const member = groupMembers.find(m => m.id === memberId);

        // Handle file upload
        if (name === 'photoFile') {
            const file = files ? files[0] : value;

            setGroupMembers(prev => prev.map(member => {
                if (member.id === memberId) {
                    return {
                        ...member,
                        photoFile: file,
                    };
                }
                return member;
            }));
            return;
        }

        // Handle photo preview
        if (name === 'photoPreview') {
            setGroupMembers(prev => prev.map(member => {
                if (member.id === memberId) {
                    return {
                        ...member,
                        photoPreview: value
                    };
                }
                return member;
            }));
            return;
        }

        // Handle phone
        if (name === 'phone') {
            const numericValue = value.replace(/\D/g, '');

            setGroupMembers(prev => prev.map(member => {
                if (member.id === memberId) {
                    return {
                        ...member,
                        [name]: numericValue,
                        phoneVerified: false,
                        emailVerified: false,
                        verificationStep: 'phone',
                        isExistingUser: false,
                        autoFilled: false,
                        hasCheckedExistingUser: false
                    };
                }
                return member;
            }));
        }
        else if (name === 'email') {
            if (!member.phoneVerified && !member.isExistingUser) {
                Swal.fire({
                    title: 'Phone Verification Required',
                    text: 'Please verify phone number first',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return;
            }

            setGroupMembers(prev => prev.map(member => {
                if (member.id === memberId) {
                    return {
                        ...member,
                        [name]: value,
                        emailVerified: false,
                        verificationStep: member.phoneVerified ? 'email' : 'phone'
                    };
                }
                return member;
            }));
        }
        else if (name === 'role') {
            if (!member.phoneVerified || !member.emailVerified) {
                // Swal.fire({
                //     title: 'Verification Required',
                //     text: 'Please verify phone and email first',
                //     icon: 'warning',
                //     confirmButtonText: 'OK',
                //     background: '#f8fafc',
                //     color: '#1f2937'
                // });
                return;
            }

            const selectedParticipant = participantTypes.find(
                participant => participant.Participant_Name === value
            );

            const participantId = selectedParticipant
                ? selectedParticipant.Participant_ID
                : '';

            // FIX: Only update the specific member, not all members
            setGroupMembers(prev =>
                prev.map(m => {
                    if (m.id === memberId) {
                        return {
                            ...m,
                            role: value,
                            participantId: participantId
                        };
                    }
                    return m;
                })
            );

            if (participantId) {
                fetchAmountForParticipant(participantId, memberId);
            }
        }
        else if (name === 'gender') {
            if (!member.phoneVerified || !member.emailVerified) {
                // Swal.fire({
                //     title: 'Verification Required',
                //     text: 'Please verify phone and email first',
                //     icon: 'warning',
                //     confirmButtonText: 'OK',
                //     background: '#f8fafc',
                //     color: '#1f2937'
                // });
                return;
            }

            setGroupMembers(prev => prev.map(member => {
                if (member.id === memberId) {
                    return { ...member, [name]: value };
                }
                return member;
            }));
        }
        else {
            setGroupMembers(prev => prev.map(member => {
                if (member.id === memberId) {
                    return { ...member, [name]: value };
                }
                return member;
            }));
        }
    };

    // Add this function in the EventRegistrationForm component
    const checkMemberPaidStatus = async (phoneNumber) => {
        if (!phoneNumber || phoneNumber.length !== 10) {
            return false;
        }

        try {
            const response = await getData(`Event/GetRegDetail/${phoneNumber}?eventid=${eventId}`);

            if (response && response.isError === false && response.result && response.result.length > 0) {
                const registration = response.result[0];

                // Check if this user is already paid for the event
                const isPaid = registration.Paid_status === 1;

                if (isPaid) {
                    const isInGroup = registration.GroupDetails && registration.GroupDetails.length > 0;

                    const maskedPhone = registration.Phone
                        ? registration.Phone.slice(-4).padStart(registration.Phone.length, 'X')
                        : 'XXXX';

                    const htmlContent = `
                        <div class="text-left">
                            <div class="flex items-start gap-4">
                                
                                <!-- Gradient Icon -->
                                <div class="w-11 h-11 flex items-center justify-center rounded-xl 
                                            bg-gradient-to-br from-indigo-500 to-purple-500 shadow-sm">
                                    <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" 
                                        d="M12 9v2m0 4h.01M4.93 19h14.14c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.2 16c-.77 1.33.19 3 1.73 3z"/>
                                    </svg>
                                </div>
                
                                <!-- Content -->
                                <div>
                                    <h3 class="text-base font-semibold text-gray-900">
                                        Registration Already Exists
                                    </h3>
                
                                    <p class="mt-2 text-sm text-gray-700 leading-relaxed">
                                        The phone number 
                                        <span class="mx-1 px-2.5 py-1 rounded-lg 
                                                     bg-indigo-50 text-indigo-600 font-semibold tracking-wide">
                                            ${maskedPhone}
                                        </span>
                                        is already registered for this event
                                        ${isInGroup
                            ? '<span class="text-purple-600 font-medium"> and included in a paid group</span>'
                            : ''
                        }.
                                    </p>
                
                                    <div class="mt-3 px-3 py-2 rounded-lg bg-gray-50 border border-gray-100">
                                        <p class="text-xs text-gray-500">
                                            Duplicate registrations are not allowed. Please try a different number .
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;

                    Swal.fire({
                        html: htmlContent,
                        showConfirmButton: true,
                        confirmButtonText: 'Understood',
                        buttonsStyling: false,
                        customClass: {
                            popup: 'rounded-2xl p-6 shadow-xl',
                            confirmButton: `
                                mt-5 px-5 py-2.5 rounded-xl 
                                bg-gradient-to-r from-blue-600 to-blue-300 
                                text-white text-sm font-semibold 
                                hover:from-blue-700 hover:to-blue-400 
                                transition-all duration-200 shadow-md
                            `
                        },
                        background: '#ffffff'
                    });

                    return true;
                }
            }
            return false; // Member is not paid
        } catch (error) {
            console.error('Error checking paid status:', error);
            return false;
        }
    };

    const handleVerifyContact = async (type, contact, memberId = null) => {
        if (!contact) {
            Swal.fire({
                title: type === 'mobile' ? 'Phone Number Required' : 'Email Required',
                text: type === 'mobile' ? 'Please enter a valid phone number first' : 'Please enter an email address first',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (type === 'mobile') {
            if (memberId) {
                setCurrentVerifyingMemberId(memberId);
            }

            // Parse the full phone number
            let fullNumber = contact;
            let countryCode = '';
            let mobileNumber = '';

            // Extract country code and mobile number
            const match = contact.match(/(\+\d+)\s*(\d+)/);
            if (match) {
                countryCode = match[1];
                mobileNumber = match[2];
            } else {
                const cleaned = contact.replace(/\D/g, '');
                if (cleaned.length > 10) {
                    countryCode = '+' + cleaned.substring(0, cleaned.length - 10);
                    mobileNumber = cleaned.substring(cleaned.length - 10);
                } else {
                    mobileNumber = cleaned;
                    countryCode = '+91'; // Default to India if no code specified
                }
            }

            // For Indian numbers, validate 10 digits before proceeding
            if (countryCode === '+91' && mobileNumber.length !== 10) {
                Swal.fire({
                    title: 'Invalid Phone Number',
                    text: 'Please enter a valid 10-digit mobile number',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                setCurrentVerifyingMemberId(null);
                return;
            }

            // Check for duplicate numbers in group members
            if (memberId) {
                const isDuplicate = groupMembers.some(member =>
                    member.phone === mobileNumber && member.id !== memberId
                );

                if (isDuplicate) {
                    Swal.fire({
                        title: 'Duplicate Phone Number',
                        text: 'This phone number is already used by another group member',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                    setCurrentVerifyingMemberId(null);
                    return;
                }
            }

            // Send OTP for Indian numbers, directly verify for international
            await sendMobileOtp({
                fullNumber: fullNumber,
                countryCode: countryCode,
                mobileNumber: mobileNumber
            }, memberId);
        } else {
            // Email verification logic remains the same
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(contact)) {
                Swal.fire({
                    title: 'Invalid Email',
                    text: 'Please enter a valid email address',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return;
            }

            if (memberId) {
                const isDuplicateEmail = groupMembers.some(member =>
                    member.email === contact && member.id !== memberId
                );

                if (isDuplicateEmail) {
                    Swal.fire({
                        title: 'Duplicate Email',
                        text: 'This email is already used by another group member',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    });
                    return;
                }
            }

            // For email, still use OTP flow
            if (memberId) {
                const member = groupMembers.find(m => m.id === memberId);
                if (!member) return;

                if (!member.phoneVerified && !member.isExistingUser) {
                    Swal.fire({
                        title: 'Phone Verification Required',
                        text: 'Please verify phone number first',
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    });
                    return;
                }

                const phone = member.phone;
                sendOtp(type, contact, phone, memberId);
            } else {
                if (!formData.phoneVerified && !formData.isExistingUser) {
                    Swal.fire({
                        title: 'Phone Verification Required',
                        text: 'Please verify phone number first',
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    });
                    return;
                }

                const phone = formData.phone;
                sendOtp(type, contact, phone, null);
            }
        }
    };

    // Function to add a new group member
    const addGroupMember = () => {
        if (groupMembers.length >= maxMembers) {
            Swal.fire({
                title: 'Maximum Members Reached',
                text: `You can only register up to ${maxMembers} members for this event.`,
                icon: 'warning',
                confirmButtonText: 'OK',
                background: '#f8fafc',
                color: '#1f2937'
            });
            return;
        }

        const newId = groupMembers.length > 0 ? Math.max(...groupMembers.map(m => m.id)) + 1 : 2;

        setGroupMembers(prev => [...prev, {
            id: newId,
            fullName: '',
            email: '',
            phone: '',
            role: '',
            gender: '',
            participantId: '',
            additionalInfo: '',
            amount: 0,
            fetchingAmount: false,
            phoneVerified: false,
            emailVerified: false,
            verificationStep: 'phone',
            isExistingUser: false,
            autoFilled: false,
            hasCheckedExistingUser: false
        }]);
    };

    // Function to remove a group member
    const removeGroupMember = (memberId) => {
        if (groupMembers.length <= 1) {
            Swal.fire({
                title: 'Cannot Remove',
                text: 'At least one member is required for registration.',
                icon: 'warning',
                confirmButtonText: 'OK',
                background: '#f8fafc',
                color: '#1f2937'
            });
            return;
        }

        Swal.fire({
            title: 'Remove Member',
            text: 'Are you sure you want to remove this member?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, remove',
            cancelButtonText: 'Cancel',
            background: '#f8fafc',
            color: '#1f2937'
        }).then((result) => {
            if (result.isConfirmed) {
                setGroupMembers(prev => prev.filter(member => member.id !== memberId));
            }
        });
    };

    const validateForm = () => {
        if (isGroupEvent) {
            for (const member of groupMembers) {
                // Check verification
                if (!member.phoneVerified || !member.emailVerified) {
                    Swal.fire({
                        title: 'Verification Required',
                        text: `Please verify phone and email for all members`,
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    });
                    return false;
                }

                // Check if this specific participant type is already paid
                // Only show error if the selected participant type matches the paid one
                if (member.isExistingUser && member.isAlreadyPaid &&
                    member.participantId && member.paidParticipantTypeId &&
                    parseInt(member.participantId) === parseInt(member.paidParticipantTypeId)) {
                    Swal.fire({
                        title: 'Already Paid',
                        text: `Member ${member.fullName || ''} has already paid for ${member.role}. Please select a different participant type.`,
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    });
                    return false;
                }

                // Check ALL required fields
                const requiredFields = [
                    'fullName', 'email', 'phone', 'role', 'gender',
                    'Prefix', 'PinCode', 'Ins_Address', 'Ins_Name'
                ];

                for (const field of requiredFields) {
                    if (!member[field] || member[field].toString().trim() === '') {
                        Swal.fire({
                            title: 'Incomplete Information',
                            text: `Please fill all required fields. Missing: ${field} for member ${member.fullName || 'Unknown'}`,
                            icon: 'warning',
                            confirmButtonText: 'OK',
                            background: '#f8fafc',
                            color: '#1f2937'
                        });
                        return false;
                    }
                }

                // Check photo
                if (!member.photoPreview && !member.isExistingUser) {
                    Swal.fire({
                        title: 'Photo Required',
                        text: `Please upload a photo for ${member.fullName || 'this member'}`,
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    });
                    return false;
                }
            }
        } else {
            // First check phone and email verification
            if (!formData.phoneVerified || !formData.emailVerified) {
                Swal.fire({
                    title: 'Verification Required',
                    text: 'Please verify phone and email before proceeding',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return false;
            }

            // Check if this specific participant type is already paid
            // Only block if the selected participant type matches the paid one
            const isSelectedTypePaid = formData.isExistingUser &&
                formData.isAlreadyPaid &&
                formData.participantId &&
                formData.paidParticipantTypeId &&
                parseInt(formData.participantId) === parseInt(formData.paidParticipantTypeId);

            if (isSelectedTypePaid) {
                Swal.fire({
                    title: 'Already Paid',
                    text: `You have already paid for ${formData.role}. Please select a different participant type.`,
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                // return false;
            }

            // Check ALL required fields
            const requiredFields = [
                'fullName', 'email', 'phone', 'role', 'gender',
                'Prefix', 'PinCode', 'Ins_Address', 'Ins_Name'
            ];

            for (const field of requiredFields) {
                if (!formData[field] || formData[field].toString().trim() === '') {
                    Swal.fire({
                        title: 'Incomplete Information',
                        text: `Please fill all required fields. Missing: ${field}`,
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        background: '#f8fafc',
                        color: '#1f2937'
                    });
                    return false;
                }
            }

            // Check photo
            if (!formData.photoPreview && !formData.isExistingUser) {
                Swal.fire({
                    title: 'Photo Required',
                    text: 'Please upload a profile photo',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    background: '#f8fafc',
                    color: '#1f2937'
                });
                return false;
            }
        }

        return true;
    };

    const proceedToRegistration = async () => {
        if (!validateForm()) {
            return;
        }

        setSubmitting(true);
        try {
            let registrationData;
            let apiEndpoint;
            let response;

            if (isGroupEvent) {
                apiEndpoint = 'Event/CreateReg';

                const firstMember = groupMembers[0];
                const additionalMembers = groupMembers.slice(1).map(member => ({
                    Name: member.fullName.trim(),
                    Email: member.email.toLowerCase().trim(),
                    Phone: member.phone,
                    Participant_type: parseInt(member.participantId) || 1,
                    Gender: member.gender || '',
                    Prefix: member.Prefix || '',
                    Inst_Name: member.Ins_Name || '',
                    Ins_Address: member.Ins_Address || '',
                    State: member.State || '',
                    District: member.District || '',
                    Pincode: member.PinCode || '',
                    Comments: member.Comments || ''
                }));

                registrationData = {
                    Reg_id: 0,
                    Event_id: eventId,
                    Inst_id: 1,
                    Name: firstMember.fullName.trim(),
                    Event_Name: event.Event_Name,
                    Email: firstMember.email.toLowerCase().trim(),
                    Phone: firstMember.phone,
                    Participant_type: parseInt(firstMember.participantId) || 1,
                    Mobile_otp: 0,
                    Reg_Cat: isGroupPayment == true ? "1" : "0",
                    Gender: firstMember.gender || '',
                    Prefix: firstMember.Prefix || '',
                    Inst_Name: firstMember.Ins_Name || '',
                    Ins_Address: firstMember.Ins_Address || '',
                    State: firstMember.State || '',
                    District: firstMember.District || '',
                    Pincode: firstMember.PinCode || '',
                    Comments: firstMember.Comments || '',
                    Message: `Group registration submitted via website (${groupMembers.length} members)`,
                    Group_Members: additionalMembers
                };

                response = await postData(apiEndpoint, registrationData);
            } else {
                apiEndpoint = 'Event/CreateEventReg';

                // FIX: Map sub-events correctly
                let subEventRegData = [];
                if (hasSubEvents && selectedSubEvents && selectedSubEvents.length > 0) {
                    subEventRegData = selectedSubEvents.map(subEventId => {
                        const subEvent = subEvents.find(s => s.SubEvent_Id === subEventId);
                        // Check if this sub-event is already paid
                        const isPaid = formData.eventDetails?.some(
                            detail => detail.SubEvent_Id === subEventId && detail.Paid_status === 1
                        );

                        return {
                            SubEvent_Id: subEventId,
                            SubEvent_Name: subEvent?.SubEvent_Name || '',
                            TotAmt: subEvent ? subEvent.TotAmt : 0,
                            Paid_Status: isPaid ? 1 : 0, // 0 for pending, 1 for already paid
                            // Add any other fields your backend expects
                        };
                    });
                }

                registrationData = {
                    Reg_id: 0,
                    Event_id: eventId,
                    Inst_id: 0,
                    Name: formData.fullName.trim(),
                    Event_Name: event.Event_Name,
                    Email: formData.email.toLowerCase().trim(),
                    Phone: formData.phone,
                    Participant_type: parseInt(formData.participantId) || 1,
                    Mobile_otp: 0,
                    Gender: formData.gender || '',
                    Prefix: formData.Prefix || '',
                    Inst_Name: formData.Ins_Name || '',
                    Ins_Address: formData.Ins_Address || '',
                    State: formData.State || '',
                    District: formData.District || '',
                    Pincode: formData.PinCode || '',
                    Comments: formData.Comments || '',
                    Message: "Registration submitted via website",
                    Group_Members: [],
                    Sub_Event_Reg: subEventRegData
                };
                response = await postData(apiEndpoint, registrationData);
            }

            if (response.isError === false) {
                setData(response.data);
                setRegistrationId(response.Result?.Reg_id);

                // Handle photo uploads for all members (existing code remains the same)
                if (isGroupEvent) {
                    // Upload photos for all group members
                    const uploadPromises = groupMembers.map(async (member) => {
                        if (member.photoFile && member.phone) {
                            try {
                                const formDataForUpload = new FormData();
                                formDataForUpload.append('phone', member.phone);
                                formDataForUpload.append('File', member.photoFile);

                                const uploadResponse = await uploadFile('event-logo/profileupload', formDataForUpload, null, false);

                                if (uploadResponse && (uploadResponse.isError === false || uploadResponse.IsError === false)) {
                                    return { success: true, phone: member.phone, name: member.fullName };
                                } else {
                                    console.warn(`Profile upload failed for ${member.phone}:`, uploadResponse?.message);
                                    return { success: false, phone: member.phone, name: member.fullName, error: uploadResponse?.message };
                                }
                            } catch (uploadError) {
                                console.error(`Error uploading profile for ${member.phone}:`, uploadError);
                                return { success: false, phone: member.phone, name: member.fullName, error: uploadError.message };
                            }
                        }
                        return null;
                    });

                    const uploadResults = await Promise.all(uploadPromises);
                    const successfulUploads = uploadResults.filter(r => r && r.success);
                    const failedUploads = uploadResults.filter(r => r && !r.success);

                    if (failedUploads.length > 0) {
                        Swal.fire({
                            title: 'Photo Upload Status',
                            html: `
                                <div class="text-left">
                                    <p class="mb-2 font-semibold text-green-600">✓ ${successfulUploads.length} photos uploaded successfully</p>
                                    ${failedUploads.length > 0 ? `
                                        <p class="font-semibold text-amber-600">⚠ ${failedUploads.length} photos failed:</p>
                                        <ul class="list-disc pl-5 mt-2 text-sm max-h-40 overflow-y-auto">
                                            ${failedUploads.map(f => `<li class="mb-1"><span class="font-medium">${f.name || f.phone}:</span> ${f.error || 'Upload failed'}</li>`).join('')}
                                        </ul>
                                        <p class="mt-3 text-sm text-gray-600">You can try uploading failed photos later from your profile.</p>
                                    ` : ''}
                                </div>
                            `,
                            icon: failedUploads.length === 0 ? 'success' : 'warning',
                            confirmButtonText: 'OK',
                            background: '#f8fafc',
                            color: '#1f2937'
                        });
                    } else if (successfulUploads.length > 0) {
                        Swal.fire({
                            title: 'Success!',
                            text: `All ${successfulUploads.length} profile photos uploaded successfully.`,
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                } else {
                    // Handle individual event photo upload
                    if (formData.photoFile && formData.phone) {
                        try {
                            const formDataForUpload = new FormData();
                            formDataForUpload.append('phone', formData.phone);
                            formDataForUpload.append('File', formData.photoFile);

                            const uploadResponse = await uploadFile('event-logo/profileupload', formDataForUpload, null, false);

                            if (uploadResponse && (uploadResponse.isError === false || uploadResponse.IsError === false)) {
                                Swal.fire({
                                    title: 'Profile uploaded successfully!',
                                    text: 'Profile photo uploaded successfully',
                                    icon: 'success',
                                    confirmButtonColor: '#3B82F6',
                                    confirmButtonText: 'OK',
                                });
                            } else {
                                console.warn('Profile upload failed:', uploadResponse?.message);
                                Swal.fire({
                                    title: 'Profile Upload Warning',
                                    text: 'Registration was saved successfully but profile upload failed. You can try uploading it later.',
                                    icon: 'warning',
                                    confirmButtonText: 'OK',
                                });
                            }
                        } catch (uploadError) {
                            console.error('Error uploading profile:', uploadError);
                            Swal.fire({
                                title: 'Profile Upload Failed',
                                text: 'Registration was saved but profile could not be uploaded. You can try uploading it later.',
                                icon: 'warning',
                                confirmButtonText: 'OK',
                            });
                        }
                    }
                }

                // Show success message for registration
                Swal.fire({
                    title: 'Registration Successful!',
                    text: `Your registration has been completed successfully. ${event.IsPaidEvent ? 'Please proceed to payment.' : ''}`,
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    setRegistrationStep('review');
                });
            } else {
                throw new Error(response?.Message || 'Registration failed. Please try again.');
            }
        } catch (error) {
            console.error('Registration error:', error);
            Swal.fire({
                title: 'Registration Failed',
                text: error.message || 'Failed to complete registration. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setSubmitting(false);
        }
    };

    // Function to proceed to payment
    const proceedToPayment = async () => {
        setTermsLoading(true);
        try {
            // Show loading state
            Swal.fire({
                title: 'Initializing Payment',
                html: `
                    <div class="text-center">
                        <div class="mb-4">
                            <div class="relative mx-auto w-16 h-16">
                                <div class="absolute inset-0 rounded-full border-4 border-blue-100"></div>
                                <div class="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 animate-spin"></div>
                                <svg class="absolute inset-2 w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                </svg>
                            </div>
                        </div>
                        <p class="text-gray-600 mb-2 font-medium">Total Amount: <span class="font-bold text-blue-700">₹${totalAmount}</span></p>
                        ${isGroupEvent ? `<p class="text-gray-600 mb-4">For ${groupMembers.length} members</p>` : ''}
                        <div class="flex items-center justify-center space-x-2 mt-4 pt-4 border-t border-gray-100">
                            <div class="flex space-x-1">
                                <div class="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                                <div class="w-2 h-2 bg-blue-500 rounded-full animate-pulse" style="animation-delay: 0.2s"></div>
                                <div class="w-2 h-2 bg-blue-500 rounded-full animate-pulse" style="animation-delay: 0.4s"></div>
                            </div>
                            <p class="text-gray-600">Redirecting to PayTM...</p>
                        </div>
                    </div>
                `,
                showConfirmButton: false,
                allowOutsideClick: false,
                background: '#ffffff',
                color: '#1f2937',
                customClass: {
                    popup: 'rounded-xl shadow-xl'
                }
            });

            // Store payment data in sessionStorage for callback handling
            const paymentSessionData = {
                eventId,
                eventName: event.Event_Name,
                totalAmount,
                registrationId,
                isGroupEvent,
                participants: isGroupEvent ? groupMembers : [formData],
                timestamp: new Date().toISOString()
            };

            sessionStorage.setItem('currentPaymentData', JSON.stringify(paymentSessionData));
            // Call the InitiatePayment API
            const response = await getData(
                `Paytm/InitiatePayment?eventId=${eventId}&Email=${data.Email}&Phone=${data.Phone}&Reg_id=${data.Reg_id}&Inst_id=${data.Inst_id}&participantID=${formData.participantId ? formData.participantId : data.Participant_type}`
            );

            if (response.isError === false && response.paytmUrl && response.parameters) {
                Swal.close();

                // Store Paytm parameters for callback handling
                sessionStorage.setItem('paytmTransactionData', JSON.stringify({
                    orderId: response.parameters.ORDER_ID,
                    amount: response.parameters.TXN_AMOUNT,
                    parameters: response.parameters,
                    paymentUrl: response.paytmUrl
                }));

                // Create and submit form to Paytm
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = response.paytmUrl;
                form.style.display = 'none';

                // Add all parameters as hidden inputs
                Object.entries(response.parameters).forEach(([key, value]) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
            } else {
                throw new Error(response?.message || 'Payment initialization failed');
            }
        } catch (error) {
            console.error('Payment initialization error:', error);
            Swal.close();

            Swal.fire({
                title: 'Payment Failed',
                text: error.message || 'Failed to initialize payment. Please try again.',
                icon: 'error',
                confirmButtonText: 'Retry',
                cancelButtonText: 'Cancel',
                showCancelButton: true,
                background: '#f8fafc',
                color: '#1f2937'
            }).then((result) => {
                if (result.isConfirmed) {
                    proceedToPayment();
                } else {
                    setTermsLoading(false);
                    setShowTermsModal(false);
                }
            });
        }
    };


    // Function to edit form
    const editForm = () => {
        setRegistrationStep('form');
        setSubmitting(false)
    };

    // Resend OTP function
    const resendOtp = async () => {
        if (otpResendTimer > 0) return;

        if (otpType === 'mobile') {
            await sendMobileOtp(currentContact, currentVerifyingMemberId);

        } else if (otpType === 'email') {
            await sendEmailOtp(currentEmail, currentContact, currentVerifyingMemberId);
        }
    };

    const getFieldDisabledStatus = (fieldName, member = null) => {
        // For IndividualForm (when member is null or undefined)
        if (!member) {
            // Use formData for individual registration
            if (fieldName === 'phone') {
                return formData.phoneVerified === true;
            }
            if (fieldName === 'email') {
                return !formData.phoneVerified && !formData.isExistingUser;
            }
            // For other fields, require both phone AND email verification
            return !formData.phoneVerified || !formData.emailVerified;
        }

        // For GroupForm (when member is provided)
        if (member.isExistingUser && member.isAlreadyPaid) return true;

        if (fieldName === 'phone') {
            // Phone field should be disabled after verification
            return member.phoneVerified === true;
        }
        if (fieldName === 'email') {
            return !member.phoneVerified && !member.isExistingUser;
        }
        // For other fields, require both phone AND email verification
        return !member.phoneVerified || !member.emailVerified;
    };



    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p className="text-gray-600 text-lg">Loading event details...</p>
                </div>
            </div>
        );
    }

    if (!event) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
                <div className="text-center">
                    <p className="text-gray-600 text-lg">Event not found</p>
                    <button
                        onClick={() => navigate('/events')}
                        className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
            {/* Main content area with internal scroll */}
            <div
                ref={contentRef}
                className="flex-1 overflow-y-auto pb-20" // pb-20 for footer space
            >
                <div className="max-w-6xl mx-auto px-4 py-6">
                    <EventHeader event={event} isGroupEvent={isGroupEvent} maxMembers={maxMembers} hasSubEvents={hasSubEvents} />

                    {registrationStep === 'form' ? (
                        <div className="relative backdrop-blur-xl bg-white mt-1 border border-white/30 shadow-2xl rounded-3xl p-8 overflow-hidden">
                            <div className="space-y-6">
                                {!isGroupEvent && (
                                    <RegistrationSteps formData={formData} />
                                )}

                                {!isGroupEvent ? (
                                    <IndividualForm
                                        formData={formData}
                                        handleInputChange={handleInputChange}
                                        handleVerifyContact={handleVerifyContact}
                                        participantTypes={participantTypes}
                                        loadingParticipantTypes={loadingParticipantTypes}
                                        getFieldDisabledStatus={getFieldDisabledStatus}
                                        verificationInProgress={verificationInProgress}
                                        otpSending={otpSending}
                                        phoneInputRef={phoneInputRef}
                                        hasSubEvents={hasSubEvents}
                                        subEvents={subEvents}
                                        loadingSubEvents={loadingSubEvents}
                                        selectedSubEvents={selectedSubEvents}  // ✅ This is correct
                                        emailInputRef={emailInputRef}
                                        setPhotoFile={setPhotoFile}
                                        photoFile={photoFile}
                                        event={event}
                                        countries={countries}
                                        honorificsOptions={honorificsOptions}
                                        setHonorificsOptions={setHonorificsOptions}
                                        setSelectedSubEvents={setSelectedSubEvents}  // ✅ This is correct
                                        handleSubEventSelection={handleSubEventSelection}  // ✅ This is correct
                                    />
                                ) : (
                                    <GroupForm
                                        honorificsOptions={honorificsOptions}
                                        setRender={setRender}
                                        countries={countries}
                                        setHonorificsOptions={setHonorificsOptions}
                                        eventId={eventId}
                                        isGroupPayment={isGroupPayment}
                                        setIsGroupPayment={setIsGroupPayment}
                                        formData={formData}
                                        verificationKey={verificationKey}
                                        handleInputChange={handleInputChange}
                                        groupMembers={groupMembers}
                                        maxMembers={maxMembers}
                                        handleGroupMemberChange={handleGroupMemberChange}
                                        handleVerifyContact={handleVerifyContact}
                                        handlePhoneBlur={handlePhoneBlur} // Add this line
                                        addGroupMember={addGroupMember}
                                        removeGroupMember={removeGroupMember}
                                        participantTypes={participantTypes}
                                        getFieldDisabledStatus={getFieldDisabledStatus}
                                        verificationInProgress={verificationInProgress}
                                        otpSending={otpSending}
                                        render={render}
                                    />
                                )}

                                {((!isGroupEvent && formData.verificationStep === 'details') ||
                                    (isGroupEvent && groupMembers.every(m => m.verificationStep === 'details'))) && (
                                        <div className="bg-gradient-to-r from-yellow-50 to-amber-50 rounded-lg p-4 border border-yellow-200">
                                            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                                                <IndianRupee className="w-5 h-5 mr-2 text-yellow-600" />
                                                Total Registration Fee
                                            </h3>
                                            <div className="text-center">
                                                <div className="inline-block bg-white px-8 py-6 rounded-lg border border-yellow-300 shadow-sm">
                                                    <div className="text-sm text-gray-500 mb-2">Total Amount Payable</div>
                                                    <div className="text-4xl font-bold text-gray-900 mb-2">
                                                        ₹{totalAmount}
                                                    </div>
                                                    <div className="text-sm text-gray-600">
                                                        {isGroupEvent ? (
                                                            <div>
                                                                For {groupMembers.length} members
                                                                {groupMembers.some(m => m.role) && (
                                                                    <div className="mt-2 text-xs text-gray-500">
                                                                        {groupMembers.map((member, index) => (
                                                                            member.role && (
                                                                                <div key={member.id} className="mb-1">
                                                                                    Member {index + 1} ({member.role}): ₹{member.amount}
                                                                                </div>
                                                                            )
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            `For ${formData.role} participant`
                                                        )}
                                                    </div>
                                                </div>

                                                {/* ALREADY PAID WARNING SECTION */}
                                                {(() => {
                                                    if (isGroupEvent) {
                                                        // Check for already paid members
                                                        const paidMembers = groupMembers.filter(member => {
                                                            return member.isExistingUser &&
                                                                member.isAlreadyPaid &&
                                                                member.participantId &&
                                                                member.paidParticipantTypeId &&
                                                                parseInt(member.participantId) === parseInt(member.paidParticipantTypeId);
                                                        });

                                                        if (paidMembers.length > 0) {
                                                            return (
                                                                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                                                                    <div className="flex items-start">
                                                                        <div className="flex-shrink-0">
                                                                            <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                            </svg>
                                                                        </div>
                                                                        <div className="ml-3 text-left">
                                                                            <h3 className="text-sm font-semibold text-red-800 mb-2">
                                                                                ⚠️ Already Paid Members
                                                                            </h3>
                                                                            <div className="space-y-1">
                                                                                {paidMembers.map((member, idx) => (
                                                                                    <p key={member.id} className="text-xs text-red-700">
                                                                                        • {member.fullName || `Member ${idx + 1}`} has already paid for <span className="font-semibold">{member.role}</span>.
                                                                                        Please select a different participant type.
                                                                                    </p>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    } else {
                                                        // Individual event - Check if already paid
                                                        const isSelectedTypePaid = formData.isExistingUser &&
                                                            formData.isAlreadyPaid &&
                                                            formData.participantId &&
                                                            formData.paidParticipantTypeId &&
                                                            parseInt(formData.participantId) === parseInt(formData.paidParticipantTypeId);

                                                        if (isSelectedTypePaid) {
                                                            return (
                                                                <div className="mt-4 p-4 ">
                                                                    <div className="flex items-center justify-center ">
                                                                        <div className='flex p-4 bg-red-50 border border-red-200 rounded-lg'>
                                                                            <div className="flex-shrink-0">
                                                                                <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                                </svg>
                                                                            </div>
                                                                            <div className="ml-3 text-left ">
                                                                                <h3 className="text-sm font-semibold text-red-800 mb-1">
                                                                                    ⚠️ Already Paid
                                                                                </h3>
                                                                                <p className="text-xs text-red-700">
                                                                                    You have already paid for <span className="font-semibold">{formData.role}</span>.
                                                                                    Please select a different participant type to register again.
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    }
                                                })()}

                                                <div className="flex my-2 items-center justify-center gap-2 bg-amber-50 px-4 py-3">
                                                    <svg className="w-5 h-5 text-amber-600" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                    </svg>
                                                    <span className="font-bold text-amber-800">Important:</span>
                                                    <span className="text-orange-900 font-semibold">This amount is non-refundable and non-transferable</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                <div className='flex justify-center pt-2 space-x-4'>
                                    <button
                                        type="button"
                                        onClick={proceedToRegistration}
                                        disabled={
                                            submitting ||
                                            totalAmount === 0 ||
                                            // Individual event checks - ADD PAID STATUS CHECK
                                            (!isGroupEvent && (
                                                !formData.phoneVerified ||
                                                !formData.emailVerified ||
                                                !formData.fullName || !formData.fullName.trim() ||
                                                !formData.email || !formData.email.trim() ||
                                                !formData.phone || !formData.phone.trim() ||
                                                !formData.role || !formData.role.trim() ||
                                                !formData.gender || !formData.gender.trim() ||
                                                !formData.Prefix || !formData.Prefix.toString().trim() ||
                                                !formData.Ins_Name || !formData.Ins_Name.trim() ||
                                                !formData.Ins_Address || !formData.Ins_Address.trim() ||
                                                !formData.PinCode || !formData.PinCode.toString().trim() ||
                                                (!formData.photoPreview && !formData.isExistingUser) ||
                                                // ADD THIS: Check if current selected participant type is the paid one
                                                (formData.isExistingUser &&
                                                    formData.isAlreadyPaid &&
                                                    formData.participantId &&
                                                    formData.paidParticipantTypeId &&
                                                    parseInt(formData.participantId) === parseInt(formData.paidParticipantTypeId))
                                            )) ||
                                            // Group event checks
                                            (isGroupEvent && groupMembers.some(member =>
                                                !member.phoneVerified ||
                                                !member.emailVerified ||
                                                !member.fullName || !member.fullName.trim() ||
                                                !member.email || !member.email.trim() ||
                                                !member.phone || !member.phone.trim() ||
                                                !member.role || !member.role.trim() ||
                                                !member.gender || !member.gender.trim() ||
                                                !member.Prefix || !member.Prefix.toString().trim() ||
                                                !member.Ins_Name || !member.Ins_Name.trim() ||
                                                !member.Ins_Address || !member.Ins_Address.trim() ||
                                                !member.PinCode || !member.PinCode.toString().trim() ||
                                                (!member.photoPreview && !member.isExistingUser) ||
                                                // Check if any member's selected participant type is the paid one
                                                (member.isExistingUser &&
                                                    member.isAlreadyPaid &&
                                                    member.participantId &&
                                                    member.paidParticipantTypeId &&
                                                    parseInt(member.participantId) === parseInt(member.paidParticipantTypeId))
                                            ))
                                        }
                                        className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-bold rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                                    >
                                        {submitting ? (
                                            <>
                                                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                                                Processing...
                                            </>
                                        ) : (
                                            <>
                                                Proceed to Review
                                                <ArrowRight className="w-5 h-5 ml-2" />
                                            </>
                                        )}
                                    </button>
                                </div>

                                <div className="text-center text-xs text-gray-500 flex items-center justify-center">
                                    <Shield className="w-3 h-3 mr-1 text-green-500" />
                                    Your information is secure and protected
                                </div>
                            </div>
                        </div>
                    ) : registrationStep === 'review' ? (
                        <ReviewSection
                            event={event}
                            isGroupEvent={isGroupEvent}
                            groupMembers={groupMembers}
                            formData={formData}
                            totalAmount={totalAmount}
                            registrationId={registrationId}
                            editForm={editForm}
                            setShowTermsModal={setShowTermsModal}
                        />
                    ) : null}
                </div>

                {/* Modals */}
                {showOtpModal && (
                    <OTPModal
                        showOtpModal={showOtpModal}
                        setShowOtpModal={setShowOtpModal}
                        otpType={otpType}
                        currentContact={currentContact}
                        currentEmail={currentEmail}
                        otp={otp}
                        handleOtpChange={handleOtpChange}
                        handleOtpKeyDown={handleOtpKeyDown}
                        otpResendTimer={otpResendTimer}
                        resendOtp={resendOtp}
                        otpVerifying={otpVerifying}
                        verifyOtp={verifyOtp}
                        otpInputRefs={otpInputRefs}
                    />
                )}

                <TermsModal
                    showTermsModal={showTermsModal}
                    setShowTermsModal={setShowTermsModal}
                    acceptedTerms={acceptedTerms}
                    setAcceptedTerms={setAcceptedTerms}
                    termsAndConditions={termsAndConditions}
                    termsLoading={termsLoading}
                    proceedToPayment={proceedToPayment}
                />
            </div>

            {/* Sticky Footer */}
            <footer className="sticky bottom-0 left-0 right-0 bg-blue-700 text-white shadow-2xl border-t border-gray-800 z-10">
                <div className="text-center p-2">
                    © 2026 All rights reserved PSG Software Technologies
                </div>
            </footer>
        </div>
    );
};

export default EventRegistrationForm;